import React, { useState, useEffect, useRef } from "react";
import { useNavigate, useParams } from "react-router-dom";
import axios from "axios";
import "./AddNewLiveStream.css";
import Select from "react-select";
import { Modal, Form, Table } from 'react-bootstrap';
import { toast } from "react-toastify"
import Button from "@mui/material/Button";
import { TagsInput } from "react-tag-input-component";
import JoditEditor from "jodit-react";
import PushNotificationSettings from "../../../components/CommonComponents/PushNotificationSettings";
import Response_Processing from "../../../../src/layout/Others/Response_Processing";
import facebook from "../../../components/Images/liveicon/facebook.png";
import twitter from "../../../components/Images/liveicon/twitter.png";
import youtube from "../../../components/Images/liveicon/youtube.png";
import useCompressImageConfig from "../../../components/CommonApis/Compressimageapi";
import usePpvGlobalImageConfig from "../../../components/CommonApis/ppv_global_change";


import { getItemToken } from "../../../Utils/localStorageUtils";
import FormContainer from "../../../components/CommonComponents/FormContainer";
import LeftWrapper from "../../../components/CommonComponents/LeftWrapper";
import Wrapper from "../../../components/CommonComponents/Wrapper";
import AdminSaveHeader from "../../../components/CommonComponents/AdminSaveHeader";
import MessageLabel from "../../../components/CommonComponents/MessageLabel";
import MessageSubHeading from "../../../components/CommonComponents/MessageSubHeading";
import AdminCustomInput from "../../../components/CommonComponents/AdminCustomInput";
import MessageHeading from "../../../components/CommonComponents/MessageHeading";
import AdminCustomArea from "../../../components/CommonComponents/AdminCustomArea";
import AdminCustomSelect from "../../../components/CommonComponents/AdminCustomSelect";
import RightWrapper from "../../../components/CommonComponents/RightWrapper";
import AdminCustomButton from "../../../components/CommonComponents/AdminCustomButton";
import AdminImageUploadZone from "../../../components/CommonComponents/AdminImageUploadZone";
import AdminCustomRadio from "../../../components/CommonComponents/AdminCustomRadio";
import AdminSwitch from "../../../components/CommonComponents/AdminSwitch";
import MessageBox from "../../../components/CommonComponents/MessageBox";
import AdminGalleryModal from "../../../components/CommonComponents/AdminGalleryModal";
import { useMyContext } from "../../../components/Provider/CommonProvider";
import AdminMiniPlayer from "../../../components/CommonComponents/AdminMiniPlayer";
import AdminYoutubePlayer from "../../../components/CommonComponents/AdminYoutubePlayer";
import AdminProcessButton from "../../../components/CommonComponents/AdminProcessButton";
import { slugGenerator } from "../../../components/CommonMethod/CommonMethods";
import { IoClose } from "react-icons/io5";
import { MdWifiTethering, MdInfo } from "react-icons/md";
import { RiFileCopyLine } from "react-icons/ri";
import AdminBackNavigation from "../../../components/CommonComponents/AdminBackNavigation";
import Defaultloadinggif from "../../../layout/Others/Defaultloadinggif";
import { navigateChecker } from "../../../components/navigateChecker";
import { connect } from "react-redux";
import FieldRenderer2 from "../../../CustomFields/FieldRenderer2";
import FieldRenderer from "../../../CustomFields/FieldRenderer";
import AdminAIModal from "../../../components/CommonComponents/AdminAImodal";
import AdminCustomURLCopy from "../../../components/CommonComponents/AdminCustomURLCopy";
import LanguageAddUpdate from "../../Language/Manage_Language/LanguageAddUpdate";
import ArtistAddUpdate from "../../Audio/Artist_Management/ArtistAddUpdate";
import LiveCategoryAddEdit from "./LiveCategoryAddEdit";
import ContentClassification from "../../Site/Settings/Site_Setting/ContentClassification";
import { MdAddCircle } from "react-icons/md";
import StorageLimitModal from "../../../components/CommonComponents/StorageLimitModal";

const AddNewLiveStream = ({ languageCodeData, siteTheme, onlyPermission }) => {

  const { handleFileChangeProvider, uploadingFiles, buildDynamicSubText, validateOrientationBySlug, validateImageRatio, fetchRequest, globalImageUplaodAPI, imageValidationAPI, fileResponse, clearFileResponse } = useMyContext()
  const imageValidationApi = imageValidationAPI()
  const { compressResolutionFormat } = useCompressImageConfig();
  const { allCurrencylistfromappi, globalPpvStatusActive } = usePpvGlobalImageConfig();
  const [showStorageModal, setShowStorageModal] = useState(false);
  useEffect(() => {
    if (fileResponse === 413) {
      setShowStorageModal(true);
    }
  }, [fileResponse]);

  const handleStorageModalClose = () => {
    setShowStorageModal(false);
    clearFileResponse();
  };

  const baseURL = process.env.REACT_APP_Baseurl
  const headers = getItemToken('access_token');
  const { id } = useParams();
  const labelSource = 'live-stream'
  const uploadFileApi = `${baseURL}/admin/library/upload?upload_type=video&clone_to=live`
  const createApi = `${baseURL}/admin/livestream/create`
  const addApi = `${baseURL}/admin/livestream/store`
  const editApi = `${baseURL}/admin/livestream/edit`
  const updateApi = `${baseURL}/admin/livestream/update`
  const labelApi = `${baseURL}/admin/Label-Management/list-source?source=${labelSource}`
  const liveUploadFile = `${baseURL}/admin/livestream/video-upload`
  const imageApi = globalImageUplaodAPI()
  const moveApi = `${baseURL}/admin/livestream/move`
  const assignApi = `${baseURL}/admin/livestream/assignto`
  const updatePPV = `${baseURL}/admin/livestream/PayPerViewPrice/StoreUpdate`
  const generateAISuggestionApi = `${baseURL}/admin/ai-prompt-response`
  const [modalTarget, setModalTarget] = useState(null);
  const [defaultPrompt, setDefaultPrompt] = useState("");


  const [customFieldValues, setCustomFieldValues] = useState({})
  const combinedRef = useRef({
    title: null,
    slug: null,
    age_restrict: null,
    selected_categories: null,
    access: null,
    rtmp_url: null,
    brightcove_video_id: null,
    stream_id: null,
    url_type: null,
    website_URL: null,
    mp4_url: null,
    m3u8_url: null,
    embed_url: null,
    image: null,
    player: null,
    tv: null,
    free_duration_time: null,
    duration: null,
    donations_label: null,
    year: null,
    publish_time: null,
    ppv_price: null,
    ios_ppv_price: null,
    description: null,
    details: null,
    Meta_description: null,
    website_page_title: null,
    rating: null,
    notification_image: useRef(null),
    content_classification: null,
    slider_image: null,
  });

  const navigate = useNavigate()

  const [formData, setFormData] = useState({
    state: "formData",
    title: "",
    slug: "",
    brightcove_video_id: "",
    push_notification_enabled: 0,
    push_notification_title: "",
    push_notification_description: "",
    push_notification_publish_type: "publish_now",
    push_notification_publish_time: "",
    source_type: 2,
    source_type_name: "Livestream",
    url_type: '',
    selected_categories: "",
    tv: "",
    image: "",
    player: "",
    age_restrict: 0,
    rating: 0,
    publish_type: "publish_now",
    free_duration_status: 0,
    enable_Tips: 0,
    enable_restream: 0,
    global_ppv: 0,
    global_ios_ppv: 0,
    // Ideabiz purchase plan mapping for live stream
    ideabiz_purchase_plans_id: null,
    google_product_id_ppvs_id: null,
    stream_id: '',
    active: 0,
    featured: 0,
    record_enable: 0,
    year: new Date().getFullYear(),
    content_classification: "",
    is_ads: 0,
    banner: 0,
    enable_live_chat: 0,
    slider_image: "",
    Slider_Thumbnail: "",
  })
  const [notificationImageFile, setNotificationImageFile] = useState(null);
  const [sliderImageFile, setSliderImageFile] = useState(null);
  const [imagerequiredValidation, setImagerequiredValidation] = useState(null)

  const [defaultOption, setDefaultOption] = useState({
    state: "defaultOption",
    artistsOption: [],
    categoryOption: [],
    languageOption: [],
    regionOption: [],
    blockCountryOption: [],
    availableCountryOption: [],
    liveSourceOption: [],
    ageOption: [],
    albumOption: [],
    accessOption: [],
    iosOption: [],
    lyricsOption: [],
    globalOption: null,
    contentClassificationOption: [],
  })

  const [labelDisplay, setLabelDisplay] = useState([]);
  const [withOutRefresh, setWithOutRefresh] = useState(false)
  const [modelClose, setModelClose] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [loading, setLoading] = useState(true);
  const [formDataError, setFormDataError] = useState({})
  const [coverImageFile, setCoverImageFile] = useState(null);
  const [playerImageFile, setPlayerImageFile] = useState(null);
  const [tvImageFile, setTvImageFile] = useState(null);
  const [liveVideo, setLiveVideo] = useState(null);
  const [showOverlay, setShowOverlay] = useState(false);
  const [scheduleImageFiles, setScheduleImageFiles] = useState({});
  const [galleryModal, setGalleryModal] = useState(false)
  const [selectedIds, setSelectedIds] = useState([]);
  const [pricemodel, setPriceModel] = useState(false);
  const [samePriceModel, setSamePriceModel] = useState(false);
  const [getGeofencing, setGetGeoFencing] = useState(null);
  const [languageModal, setLanguageModal] = useState(false);
  const [artistModal, setArtistModal] = useState(false);
  const [categoryModal, setCategoryModal] = useState(false);
  const [contentClassificationModal, setContentClassificationModal] = useState(false);
  const [getGeofencingAvailableCountries, setGetGeoFencingAvailableCountries] = useState(null);
  const [page_for, setPageFor] = useState();
  const [checkFileUpload, setCheckFileUpload] = useState(false);
  const [uploadLiveId, setUploadLiveId] = useState();
  const [moveVideo, setMoveVideo] = useState(false);
  const [convertPrice, setConvertPrice] = useState({
    source_type: 2,
    PPVType: "",
    PriceType: "",
    ActualPrice: "",
    IOSPrice: "",
    convertedPriceRates: []
  })

  const currentYear = new Date().getFullYear();

  const years = Array.from({ length: currentYear - 1895 + 1 }, (_, index) => ({ name: 1895 + index, value: 1895 + index }));

  const handleClearSelectFile = (value) => {
    if (value == 'image') {
      setCoverImageFile(null)
    }
    if (value == 'tv') {
      setTvImageFile(null)
    }
    if (value == 'player') {
      setPlayerImageFile(null)
    }
    if (value == 'notification_image') {
      setNotificationImageFile(null)
    }
    if (value == 'slider_image') {
      setSliderImageFile(null)
    }
    if (value == 'live_video') {
      setLiveVideo(null)
      setFormData((prev) => ({
        ...prev,
        ['live_video']: ""
      }))
    }
    setFormDataError((prev) => ({
      ...prev,
      [value]: ""
    }))

  }


  const handleFileChange = async (event) => {
    const { files, name, value, accept, dataset } = event.target;
    const checkSize = compressResolutionFormat?.live == "1";
    const allowedTypes = ['image/jpeg', 'image/png', 'image/jpg', 'image/webp'];

    setFormDataError((prev) => ({
      ...prev,
      [name]: "",
    }));

    if (files?.length > 0) {
      const newFile = files[0];

      // Image type validation for image files
      if (name !== 'live_video' && !allowedTypes.includes(files[0]?.type)) {
        setFormDataError((prev) => ({
          ...prev,
          [name]: "Only JPG, JPEG, WEBP and PNG files are allowed.",
        }));
        if (name === 'image') setCoverImageFile(null);
        if (name === 'player') setPlayerImageFile(null);
        if (name === 'tv') setTvImageFile(null);
        if (name === 'notification_image') setNotificationImageFile(null);
        if (combinedRef.current[name]) {
          combinedRef.current[name].focus();
        }
        return;
      }

      const readFile = (file) => {
        return new Promise((resolve, reject) => {
          const reader = new FileReader();
          reader.onload = () => resolve(reader.result);
          reader.onerror = (error) => reject(error);
          reader.readAsDataURL(file);
        });
      };
      const fileContent = await readFile(newFile);

      if (name == 'image') {
        setCoverImageFile(newFile);
        if (dataset?.orientation) {
          const result = await validateOrientationBySlug(newFile, dataset.orientation);
          if (!result.ok) {
            let msg = 'Selected image does not match the required orientation.';
            if (result?.expected) {
              const ratio = `${result.expected.width}:${result.expected.height}`;
              msg = `Image must be in ${result?.ratio || ratio} Ratio or ${result.expected.width}x${result.expected.height}px`;
            }
            setFormDataError((prev) => ({ ...prev, [name]: msg }));
            setCoverImageFile(null);
            if (combinedRef.current[name]) {
              combinedRef.current[name].focus();
            }
            return;
          }
        } else {
          const isValidSize = await validateImageRatio(newFile, 2 / 3, 1080, 1620);
          if (!isValidSize) {
            setFormDataError((prev) => ({ ...prev, [name]: "Image must be in 2:3 Ratio or 1080x1620px." }));
            setCoverImageFile(null);
            if (combinedRef.current[name]) {
              combinedRef.current[name].focus();
            }
            return;
          }
        }
      }

      if (name == 'player') {
        setPlayerImageFile(newFile);
        if (dataset?.orientation) {
          const result = await validateOrientationBySlug(newFile, dataset.orientation);
          if (!result.ok) {
            let msg = 'Selected image does not match the required orientation.';
            if (result?.expected) {
              const ratio = `${result.expected.width}:${result.expected.height}`;
              msg = `Image must be in ${result?.ratio || ratio} Ratio or ${result.expected.width}x${result.expected.height}px`;
            }
            setFormDataError((prev) => ({ ...prev, [name]: msg }));
            setPlayerImageFile(null);
            if (combinedRef.current[name]) {
              combinedRef.current[name].focus();
            }
            return;
          }
        } else {
          const isValidSize = await validateImageRatio(newFile, 16 / 9, 1280, 720);
          if (!isValidSize) {
            setFormDataError((prev) => ({ ...prev, [name]: "Image must be in 16:9 Ratio or 1280x720px." }));
            setPlayerImageFile(null);
            if (combinedRef.current[name]) {
              combinedRef.current[name].focus();
            }
            return;
          }
        }
      }

      if (name == 'tv') {
        setTvImageFile(newFile);
        if (dataset?.orientation) {
          const result = await validateOrientationBySlug(newFile, dataset.orientation);
          if (!result.ok) {
            let msg = 'Selected image does not match the required orientation.';
            if (result?.expected) {
              const ratio = `${result.expected.width}:${result.expected.height}`;
              msg = `Image must be in ${result?.ratio || ratio} Ratio or ${result.expected.width}x${result.expected.height}px`;
            }
            setFormDataError((prev) => ({ ...prev, [name]: msg }));
            setTvImageFile(null);
            if (combinedRef.current[name]) {
              combinedRef.current[name].focus();
            }
            return;
          }
        } else {
          const isValidSize = await validateImageRatio(newFile, 16 / 9, 1280, 720);
          if (!isValidSize) {
            setFormDataError((prev) => ({ ...prev, [name]: "Image must be in 16:9 Ratio or 1280x720px." }));
            setTvImageFile(null);
            if (combinedRef.current[name]) {
              combinedRef.current[name].focus();
            }
            return;
          }
        }
      }

      if (name === 'notification_image') {
        setNotificationImageFile(newFile);
        // Add validation for notification image if needed
      }
      if (name === 'slider_image') {
        setSliderImageFile(newFile);
        const isValidRatio = await validateImageRatio(newFile, 8 / 3, 3840, 1440);
        if (!isValidRatio && compressResolutionFormat?.disable_image_ratio_validation !== 1) {
          setFormDataError((prev) => ({
            ...prev,
            [name]: "Slider image must be in 8:3 Ratio or 3840x1440px.",
          }));
        }
      }

      if (name === 'live_video') {
        setLiveVideo(newFile);
        setFormData((prev) => ({
          ...prev,
          "live_video": newFile
        }));
      }
    }
  };

  const multiSelectLabel = (array, valueKey, labelKey) => {
    return Array.isArray(array) ? array?.map((item) => ({
      value: item[valueKey],
      label: item[labelKey]
    })) : [];
  };

  const fetchData = async () => {
    setLoading(true)
    try {
      const response = await axios.get(`${editApi}/${id}`, { headers: headers });

      const result = response?.data?.data;
      setGetGeoFencing(result?.getGeofencing);
      setGetGeoFencingAvailableCountries(result?.getGeofencingAvailableCountries);
      const previousFormData = result?.livestream;

      const updatedFormData = {
        ...previousFormData,
        selected_artists: multiSelectLabel(previousFormData?.Selected_artists, 'id', 'artist_name'),
        selected_categories: previousFormData?.Selected_Livecategory?.map(c => c.id) || [],
        selected_Languages: multiSelectLabel(previousFormData?.Selected_Languages, 'id', 'name'),
        selected_Regions: multiSelectLabel(previousFormData?.Selected_Regions, 'id', 'name'),
        selected_blocked_country: multiSelectLabel(previousFormData?.Selected_Block_coutries, 'id', 'name'),
        selected_available_country: multiSelectLabel(previousFormData?.Selected_available_coutries, 'id', 'country_name'),
        age_restrict: assignDefault(previousFormData.age_restrict),
        ideabiz_purchase_plans_id: previousFormData?.ideabiz_purchase_plans_id || null,
        google_product_id_ppvs_id: previousFormData?.google_product_id_ppvs_id || null,
        search_tags: previousFormData?.search_tags?.split(",")?.map((tag) => tag.trim()),
        rtmp_type: result?.rtmpOption?.map(item => ({ name: item?.name, value: item?.value })),
        stream_id: result?.Livestream_source
          ?.filter((item) => item?.value === "Encode_stream_video")
          ?.flatMap((item) => item?.Rtmp_urls || [])
          ?.find((rtmpItem) =>
            rtmpItem?.rtmp_url?.split("/")?.pop() === previousFormData?.Stream_key
              ? rtmpItem?.rtmp_url?.split("/")?.pop()
              : ''
          ),
        brightcove_video_id: previousFormData?.brightcove_video_id || "",
        schedule_programs: result?.schedule_programs || [],
        push_notification_enabled: previousFormData?.push_notification_enabled || 0,
        push_notification_title: previousFormData?.push_notification_title || "",
        push_notification_description: previousFormData?.push_notification_description || "",
        push_notification_publish_type: previousFormData?.push_notification_publish_type || "publish_now",
        push_notification_publish_time: previousFormData?.push_notification_publish_time || "",
        push_notification_image: previousFormData?.push_notification_image || "",
        source_type: 2,
        source_type_name: "Livestream",
        slug: previousFormData?.slug || "",
        enable_live_chat: previousFormData?.enable_live_chat || 0,
      }
      setFormData(updatedFormData);
      setPageFor(response?.data?.page_for);

      // Default DropDown List

      const defaultoptionslist = {
        artistsOption: multiSelectLabel(result.artists, 'id', 'artist_name'),
        categoryOption: result.livestream_category,
        languageOption: multiSelectLabel(result.livestream_language, 'id', 'name'),
        regionOption: multiSelectLabel(result.regions, 'id', 'name'),
        blockCountryOption: multiSelectLabel(result.Country, 'id', 'name'),
        availableCountryOption: multiSelectLabel(result.Country, 'id', 'name'),
        ageOption: result?.Age || [],
        accessOption: result?.user_access,
        liveSourceOption: result?.Livestream_source,
        rtmpOption: result?.Livestream_source
          .filter((item) => item.value === "Encode_stream_video")
          .flatMap((item) => item.Rtmp_urls)
          .map((rtmpItem) => ({ name: `Streaming Video ${rtmpItem?.id}`, value: rtmpItem?.id, rtmp_url: rtmpItem?.rtmp_url, hls_url: rtmpItem?.hls_url })),
        globalOption: result?.ppv_gobal_price ? result?.ppv_gobal_price : 0,
        iosOption: result?.InappPurchases || [],
        defaultCurrency: result?.DefaultCurrency,
        // Ideabiz PPV purchase plans for live (edit API)
        ideabizPPVPurchase: result?.ideabizPPVPurchase || [],
        googleProductIdPPV: result?.googleProductIdPPV || [],
        preAdvertisement: result?.pre_advertisement || [],
        midAdsCategory: result?.ads_category || [],
        contentClassificationOption: multiSelectLabel(result?.AllClassification, 'title', 'title'),
      }

      if (!defaultoptionslist.googleProductIdPPV || defaultoptionslist.googleProductIdPPV.length === 0) {
        try {
          const createResponse = await axios.get(`${createApi}`, { headers: headers });
          if (createResponse?.data?.data?.googleProductIdPPV?.length) {
            defaultoptionslist.googleProductIdPPV = createResponse.data.data.googleProductIdPPV;
          }
        } catch (error) {
          console.error("Error fetching fallback googleProductIdPPV:", error);
        }
      }
      setDefaultOption(defaultoptionslist);

      if (updatedFormData.content_classification) {
        const selectedTitles = updatedFormData.content_classification.split(',').map(item => item.trim());
        const selected = defaultoptionslist.contentClassificationOption.filter(opt => selectedTitles.includes(opt.value));
        setFormData(prev => ({ ...prev, selected_content_classification: selected }));
      }
      setConvertPrice(prevState => {
        return {
          ...prevState,
          PPVType: formData?.global_ppv,
          PriceType: result?.DefaultCurrency?.code,
          ActualPrice: formData?.ppv_price,
          IOSPrice: formData?.ios_ppv_price,
          convertedPriceRates: [...result?.ContentPriceRates]
        };
      });
      setLoading(false)
    } catch (error) {
      console.error(error);
    }
  };

  const fetchCreate = async () => {
    try {
      const response = await axios.get(`${createApi}`, { headers: headers });
      const result = response?.data?.data;
      // if (result) {
      //   toast.success(response?.data?.message)
      // }

      // Default DropDown List

      const defaultoptionslist = {
        artistsOption: multiSelectLabel(result?.artists, 'id', 'artist_name'),
        categoryOption: result?.livestream_category,
        languageOption: multiSelectLabel(result?.livestream_language, 'id', 'name'),
        regionOption: multiSelectLabel(result?.regions, 'id', 'name'),
        blockCountryOption: multiSelectLabel(result?.Country, 'id', 'name'),
        availableCountryOption: multiSelectLabel(result?.Country, 'id', 'name'),
        liveSourceOption: result?.Livestream_source,
        rtmpOption: result?.Livestream_source
          .filter((item) => item.value === "Encode_stream_video")
          .flatMap((item) => item.Rtmp_urls)
          .map((rtmpItem) => ({ name: `Streaming Video ${rtmpItem?.id}`, value: rtmpItem?.id, rtmp_url: rtmpItem?.rtmp_url, hls_url: rtmpItem?.hls_url })),
        ageOption: result?.Age,
        accessOption: result?.user_access,
        iosOption: result?.InappPurchases || [],
        defaultCurrency: result?.DefaultCurrency,
        globalOption: result?.ppv_gobal_price ? result?.ppv_gobal_price : 0,
        // Ideabiz PPV purchase plans for live (create API)
        ideabizPPVPurchase: result?.ideabizPPVPurchase || [],
        googleProductIdPPV: result?.googleProductIdPPV || [],
        preAdvertisement: result?.pre_advertisement || [],
        midAdsCategory: result?.ads_category || [],
        contentClassificationOption: multiSelectLabel(result?.AllClassification, 'title', 'title'),
      }
      setFormData(prev => ({
        ...prev,
        rtmp_type: result?.rtmpOption?.map(item => ({ name: item?.name, value: item?.value })),
        schedule_programs: [], // Initialize empty for new creation
        source_type: 2,
        source_type_name: "Livestream",
      }))
      setDefaultOption(defaultoptionslist);
      setGetGeoFencing(result?.getGeofencing);
      setGetGeoFencingAvailableCountries(result?.getGeofencingAvailableCountries);
      setPageFor(response?.data?.page_for);
      setLoading(false)
    } catch (error) {
      console.error(error);
    }
  };

  const assignDefault = (value, defaultValue = 0) => value ? value : defaultValue;

  const closeModal = () => {
    setModelClose(!closeModal);
    setShowModal(false);
  };

  const labelFetch = async () => {
    try {
      setShowOverlay(true)
      const response = await axios.get(`${labelApi}`, { headers: headers });
      const result = response?.data?.label_management
      setLabelDisplay(result)
      setShowOverlay(false)
    }
    catch (err) {
      setShowOverlay(false)
      toast.error(err.response.data.message)

    }
  }

  const handleInput = (e) => {
    const { name, value, type, checked } = e.target;


    if (name === "free_duration_time" || name === "duration" || name === "mid_advertisement_sequence_time") {
      const digitsOnly = value.replace(/\D/g, "");

      if (digitsOnly.length <= 6) {
        let formattedTime = digitsOnly;
        if (digitsOnly.length === 6) {
          const hours = parseInt(digitsOnly.slice(0, 2));
          const minutes = parseInt(digitsOnly.slice(2, 4));
          const seconds = parseInt(digitsOnly.slice(4, 6));

          if (hours <= 23 && minutes <= 59 && seconds <= 59) {
            formattedTime = `${digitsOnly.slice(0, 2)}:${digitsOnly.slice(2, 4)}:${digitsOnly.slice(4, 6)}`;
          } else {
            setFormDataError((prev) => ({
              ...prev,
              [name]: "Please enter a valid time (HH:MM:SS format, hours: 00-23, minutes/seconds: 00-59)",
            }));
            return;
          }
        }

        setFormData((prev) => ({
          ...prev,
          [name]: formattedTime,
        }));

        setFormDataError((prev) => ({
          ...prev,
          [name]: '',
        }));
      }
      return;
    }

    if (type === "radio") {
      if (name == "publish_now" || name == "publish_later") {
        setFormData((prev) => ({
          ...prev,
          publish_type: checked ? name : ''
        }));
      }
      if (name == "global_ppv") {
        setFormData((prev) => ({
          ...prev,
          [name]: value
        }));
      }
      if (name === "push_notification_publish_now" || name === "push_notification_publish_later") {
        setFormData((prev) => ({
          ...prev,
          push_notification_publish_type: checked ? name.replace('push_notification_', '') : '',
        }));
      }
    }

    if (type === "checkbox") {
      setFormData((prev) => ({
        ...prev,
        [name]: checked ? 1 : 0,
      }));
      if (name == "free_duration_status") {
        if (!checked) {
          setFormDataError((prev) => ({
            ...prev,
            ['free_duration_time']: '',
          }));
        }
      }
      if (name == "enable_Tips") {
        if (!checked) {
          setFormDataError((prev) => ({
            ...prev,
            ['donations_label']: '',
          }));
        }

      }
      if (name == "global_ppv") {
        if (checked) {
          setFormData((prev) => ({
            ...prev,
            ['ppv_price']: defaultOption?.globalOption,
          }));
        }
        else {
          setFormData((prev) => ({
            ...prev,
            ['ppv_price']: '',
          }));
        }

      }
    }

    if (type === 'text') {
      setFormData((prev) => ({
        ...prev,
        [name]: value,
      }));
      setFormDataError((prev) => ({
        ...prev,
        [name]: '',
      }));
    }

    if (type === 'select-one') {
      setFormData((prev) => ({
        ...prev,
        [name]: value,
      }));
      setFormDataError((prev) => ({
        ...prev,
        [name]: '',
      }));
    }

    if (type === "datetime-local") {
      setFormData((prev) => ({
        ...prev,
        [name]: value,
      }));
    }

    if (type === "textarea") {
      setFormData((prev) => ({
        ...prev,
        [name]: value,
      }));
    }
    if (type === "number") {
      setFormData((prev) => ({
        ...prev,
        [name]: value,
      }));
      setFormDataError((prev) => ({
        ...prev,
        [name]: '',
      }));
    }

  };

  const handleTagsChange = (newTags) => {
    const cleanedTags = (newTags || [])
      .flatMap((tag) => String(tag ?? "").split(","))
      .map((tag) => tag.trim().toLowerCase())
      .filter((tag) => tag !== "")
      .filter((value, index, self) => self.indexOf(value) === index);
    setFormData((prevFormData) => ({
      ...prevFormData,
      search_tags: cleanedTags,
    }));
  };

  useEffect(() => {
    const fetchImageValidation = async () => {
      const ImageValidationresponse = await fetchRequest({
        method: "GET",
        url: imageValidationApi,
        params: {},
        data: {},
      });
      setImagerequiredValidation(ImageValidationresponse?.Compress_image);
    };
    fetchImageValidation();
  }, []);

  const handleBlurtitle = () => {
    if (!formData?.slug) {
      generateSlug(formData?.title);
    }
  };

  const generateSlug = async (title) => {
    const slug = await slugGenerator(title)
    setFormData((prev) => ({
      ...prev,
      'slug': slug,
    }));
  };

  const handleInputKeyDowntitle = (event) => {
    if (!formData?.slug) {
      if (event.key === "Enter" || event.key === "Tab") {
        generateSlug(formData?.title);
      }
    }
  };

  const handleMultiSelect = (selectedOptions, actionMeta) => {
    setFormData((prev) => ({
      ...prev,
      [actionMeta.name]: selectedOptions
    }))
    setFormDataError((prev) => ({
      ...prev,
      [actionMeta.name]: ""
    }))
  }

  const formValidation = () => {
    let formIsValid = true;
    if (!formData?.title || formData.title.trim() === '') {
      setFormDataError((prevFormData) => ({
        ...prevFormData,
        title: "Title cannot be empty or contain only spaces.",
      }));
      if (combinedRef.current['title']) {
        combinedRef.current['title'].focus()
      }
      formIsValid = false;
    }
    if (!formData?.slug || formData.slug.trim() === '') {
      setFormDataError((prevFormData) => ({
        ...prevFormData,
        slug: "Slug cannot be empty or contain only spaces.",
      }));
      if (combinedRef.current['slug']) {
        combinedRef.current['slug'].focus()
      }
      formIsValid = false;
    }
    if (!formData?.age_restrict) {
      setFormDataError((prevFormData) => ({
        ...prevFormData,
        age_restrict: "Age cannot be empty.",
      }));
      if (combinedRef.current['age_restrict']) {
        combinedRef.current['age_restrict'].focus()
      }
      formIsValid = false;
    }
    if (!formData?.access) {
      setFormDataError((prevFormData) => ({
        ...prevFormData,
        access: "Choose the access.",
      }));
      if (combinedRef.current['access']) {
        combinedRef.current['access'].focus()
      }
      formIsValid = false;
    }
    if (!formData?.url_type) {
      setFormDataError((prevFormData) => ({
        ...prevFormData,
        url_type: "choose url or file.",
      }));
      if (combinedRef.current['url_type']) {
        combinedRef.current['url_type'].focus()
      }
      formIsValid = false;
    }

    if (formData?.website_URL) {
      const urlPattern = /^https?:\/\/(?:[-\w.])+(?::[0-9]+)?(?:\/[^?\s]*)?(?:\?[^#\s]*)?(?:#[^\s]*)?$/i;
      if (!urlPattern.test(formData.website_URL)) {
        setFormDataError((prevFormData) => ({
          ...prevFormData,
          website_URL: "Please enter a valid URL format starting with http:// or https://",
        }));
        if (combinedRef.current['website_URL']) {
          combinedRef.current['website_URL'].focus()
        }
        formIsValid = false;
      }
    }

    if (!id && formData?.url_type === "mp4_video_upload" && checkFileUpload === false && selectedIds?.length <= 0) {
      setFormDataError((prevFormData) => ({
        ...prevFormData,
        url_type: "Please select a file to upload.",
      }));
      if (combinedRef.current['url_type']) {
        combinedRef.current['url_type'].focus()
      }
      formIsValid = false;
    }

    if (formData?.url_type === "brightcove" && !formData?.brightcove_video_id) {
      setFormDataError((prevFormData) => ({
        ...prevFormData,
        brightcove_video_id: "Brightcove Video ID is required.",
      }));
      if (combinedRef.current['brightcove_video_id']) {
        combinedRef.current['brightcove_video_id'].focus();
      }
      formIsValid = false;
    }

    if (formData?.url_type === "mp4_url" && (!formData?.mp4_url || !formData.mp4_url.endsWith('.mp4') || formData.mp4_url.trim() !== formData.mp4_url)) {
      setFormDataError((prevFormData) => ({
        ...prevFormData,
        mp4_url: "Please provide a valid MP4 URL ending with .mp4",
      }));
      if (combinedRef.current['mp4_url']) {
        combinedRef.current['mp4_url'].focus();
      }
      formIsValid = false;
    }

    if (formData?.url_type === "m3u8_url" && (!formData?.m3u8_url || !formData.m3u8_url.endsWith('.m3u8') || formData.m3u8_url.trim() !== formData.m3u8_url)) {
      setFormDataError((prevFormData) => ({
        ...prevFormData,
        m3u8_url: "Please provide a valid M3U8 URL ending with .m3u8",
      }));
      if (combinedRef.current['m3u8_url']) {
        combinedRef.current['m3u8_url'].focus();
      }
      formIsValid = false;
    }

    if (formData?.url_type === "embed_url") {
      if (!formData?.embed_url?.trim()) {
        setFormDataError((prevFormData) => ({
          ...prevFormData,
          embed_url: "Embed code cannot be empty.",
        }));
        if (combinedRef.current['embed_url']) {
          combinedRef.current['embed_url'].focus();
        }
        formIsValid = false;
        return;
      }

      const embedCode = formData.embed_url.trim();
      const youtubeEmbedRegex = /^https?:\/\/(?:www\.)?youtube?\.com\/embed\/[a-zA-Z0-9_-]+(?:\?[a-zA-Z0-9_=&-]+)*$/;

      if (!youtubeEmbedRegex.test(embedCode)) {
        setFormDataError((prevFormData) => ({
          ...prevFormData,
          embed_url: "Invalid YouTube embed URL. Format: https://www.youtube.com/embed/VIDEO_ID",
        }));
        if (combinedRef.current['embed_url']) {
          combinedRef.current['embed_url'].focus();
        }
        formIsValid = false;
        return;
      }
    }

    if (formDataError?.image) {
      if (combinedRef.current['image']) {
        combinedRef.current['image'].focus()
      }
      formIsValid = false;
    }
    if (formDataError?.player) {
      if (combinedRef.current['player']) {
        combinedRef.current['player'].focus()
      }
      formIsValid = false;
    }
    if (formDataError?.tv) {
      if (combinedRef.current['tv']) {
        combinedRef.current['tv'].focus()
      }
      formIsValid = false;
    }
    if (formData?.free_duration_status) {
      const rawDuration = formData?.free_duration_time?.replace(/\D/g, '');
      if (!formData?.free_duration_time || rawDuration.length !== 6) {
        setFormDataError((prevFormData) => ({
          ...prevFormData,
          free_duration_time: "Free Duration must be exactly 6 digits in HH:MM:SS format.",
        }));
        if (combinedRef.current['free_duration_time']) {
          combinedRef.current['free_duration_time'].focus();
        }
        formIsValid = false;
      } else {
        const [hh, mm, ss] = [
          rawDuration.slice(0, 2),
          rawDuration.slice(2, 4),
          rawDuration.slice(4, 6)
        ];

        const hours = parseInt(hh, 10);
        const minutes = parseInt(mm, 10);
        const seconds = parseInt(ss, 10);

        const isValidTime =
          hours >= 0 && hours <= 23 &&
          minutes >= 0 && minutes <= 59 &&
          seconds >= 0 && seconds <= 59;

        if (!isValidTime || (hours === 0 && minutes === 0 && seconds === 0)) {
          setFormDataError((prevFormData) => ({
            ...prevFormData,
            free_duration_time: "Free Duration must be a valid time (not 00:00:00).",
          }));
          if (combinedRef.current['free_duration_time']) {
            combinedRef.current['free_duration_time'].focus();
          }
          formIsValid = false;
        }
      }
    }

    if (formData?.duration) {
      const rawDuration = formData.duration.replace(/\D/g, '');
      if (rawDuration.length !== 6) {
        setFormDataError((prevFormData) => ({
          ...prevFormData,
          duration: "Duration must be exactly 6 digits in HH:MM:SS format.",
        }));
        if (combinedRef.current['duration']) {
          combinedRef.current['duration'].focus();
        }
        formIsValid = false;
      } else {
        const hours = parseInt(rawDuration.slice(0, 2), 10);
        const minutes = parseInt(rawDuration.slice(2, 4), 10);
        const seconds = parseInt(rawDuration.slice(4, 6), 10);

        if (
          hours > 23 || minutes > 59 || seconds > 59 ||
          (hours === 0 && minutes === 0 && seconds === 0)
        ) {
          setFormDataError((prevFormData) => ({
            ...prevFormData,
            duration: "Please enter a valid time between 00:00:01 and 23:59:59",
          }));
          if (combinedRef.current['duration']) {
            combinedRef.current['duration'].focus();
          }
          formIsValid = false;
        }
      }
    }

    if (formData?.enable_Tips) {
      if (!formData?.donations_label) {
        setFormDataError((prevFormData) => ({
          ...prevFormData,
          donations_label: "Donate price cannot be empty.",
        }));
        if (combinedRef.current['donations_label']) {
          combinedRef.current['donations_label'].focus()
        }
        formIsValid = false;
      }
    }

    if (!formData?.selected_categories || formData?.selected_categories?.length <= 0) {
      setFormDataError((prevFormData) => ({
        ...prevFormData,
        selected_categories: "Category cannot be empty.",
      }));
      if (combinedRef.current['selected_categories']) {
        combinedRef.current['selected_categories'].focus()
      }
      formIsValid = false;
    }

    if (formData?.url_type == "mp4_url") {
      if (!formData?.mp4_url) {
        setFormDataError((prevFormData) => ({
          ...prevFormData,
          mp4_url: "Mp4 url cannot be empty",
        }));
        if (combinedRef.current['mp4_url']) {
          combinedRef.current['mp4_url'].focus()
        }
        formIsValid = false;
      }
    }
    if (formData?.url_type == "embed_url") {
      if (!formData?.embed_url) {
        setFormDataError((prevFormData) => ({
          ...prevFormData,
          embed_url: "Embed url cannot be empty",
        }));
        if (combinedRef.current['embed_url']) {
          combinedRef.current['embed_url'].focus()
        }
        formIsValid = false;
      }
    }
    if (formData?.url_type == "m3u8_url") {
      // if (!formData?.m3u_url) {
      //   setFormDataError((prevFormData) => ({
      //     ...prevFormData,
      //     m3u_url: "m3u url cannot be empty",
      //   }));
      //   combinedRef.current['m3u_url'].focus()
      //   formIsValid = false;
      // }
      if (!formData?.m3u8_url) {
        setFormDataError((prevFormData) => ({
          ...prevFormData,
          m3u8_url: "m3u8 url cannot be empty",
        }));
        if (combinedRef.current['m3u8_url']) {
          combinedRef.current['m3u8_url'].focus()
        }
        formIsValid = false;
      }
    }
    if (formData?.url_type == "Encode_stream_video") {
      if (!formData?.stream_id && !formData?.rtmp_url) {
        setFormDataError((prevFormData) => ({
          ...prevFormData,
          rtmp_url: "choose stream url",
        }));
        if (combinedRef.current['rtmp_url']) {
          combinedRef.current['rtmp_url'].focus()
        }
        formIsValid = false;
      }
    }
    if (formData?.publish_type == "publish_now") {
      if (!formData?.year) {
        setFormDataError((prevFormData) => ({
          ...prevFormData,
          year: "Year cannot be empty.",
        }));
        if (combinedRef.current['year']) {
          combinedRef.current['year'].focus()
        }
        formIsValid = false;
      }
    }
    if (formData?.publish_type == "publish_later") {
      if (!formData?.publish_time) {
        setFormDataError((prevFormData) => ({
          ...prevFormData,
          publish_time: "Publish time cannot be empty.",
        }));
        if (combinedRef.current['publish_time']) {
          combinedRef.current['publish_time'].focus()
        }
        formIsValid = false;
      }
    }

    if (!formData?.title || formData?.title.trim().length < 3 || formData?.title.trim().length > 100) {
      toast.error("Title must be between 3 and 100 characters.");
      formIsValid = false;
    }

    if (!formData?.slug || formData?.slug.trim().length < 3 || formData?.slug.trim().length > 100) {
      toast.error("Slug must be between 3 and 100 characters.");
      formIsValid = false;
    }

    if (imagerequiredValidation?.live === 1) {
      if (((id && (formData?.image?.includes('default_vertical_image.webp') || formData?.image?.includes('uploads/settings/'))) || (!id && !coverImageFile)) && !coverImageFile) {
        setFormDataError(prev => ({
          ...prev,
          image: "Please provide cover image"
        }))
        if (combinedRef.current['image']) {
          combinedRef.current['image'].focus()
        }
        formIsValid = false;
      }
      if (((id && (formData?.player?.includes('default_horizontal_image.webp') || formData?.player?.includes('uploads/settings/'))) || (!id && !playerImageFile)) && !playerImageFile) {
        setFormDataError(prev => ({
          ...prev,
          player: "Please provide player image"
        }))
        if (combinedRef.current['player']) {
          combinedRef.current['player'].focus()
        }
        formIsValid = false;
      }
      if (((id && (formData?.Tv_live_image?.includes('default_horizontal_image.webp') || formData?.Tv_live_image?.includes('uploads/settings/'))) || (!id && !tvImageFile)) && !tvImageFile) {
        setFormDataError(prev => ({
          ...prev,
          tv: "Please provide tv image"
        }))
        if (combinedRef.current['tv']) {
          combinedRef.current['tv'].focus()
        }
        formIsValid = false;
      }
    }

    // Validate schedule programs
    if (Number(siteTheme?.enable_epg) === 1 && formData.schedule_programs && formData.schedule_programs.length > 0) {
      formData.schedule_programs.forEach((program) => {
        if (!program.name || program.name.trim() === '') {
          setFormDataError(prev => ({
            ...prev,
            [`schedule_program_${program.id}_name`]: "Program name is required"
          }));
          formIsValid = false;
        }
        if (!program.description || program.description.trim() === '') {
          setFormDataError(prev => ({
            ...prev,
            [`schedule_program_${program.id}_description`]: "Program description is required"
          }));
          formIsValid = false;
        }
        if (!program.days || program.days.length === 0) {
          toast.error(`Please select at least one day for program "${program.name || `Program`}"`);
          formIsValid = false;
        }
        if (!program.start_time) {
          toast.error(`Please select a start time for program "${program.name || `Program`}"`);
          formIsValid = false;
        }
        if (!program.end_time) {
          toast.error(`Please select an end time for program "${program.name || `Program`}"`);
          formIsValid = false;
        }
      });
    }

    // Push Notification Validation
    if (formData.push_notification_enabled) {
      if (!formData.push_notification_title || formData.push_notification_title.trim() === '') {
        setFormDataError((prevFormData) => ({
          ...prevFormData,
          push_notification_title: "Push notification title cannot be empty.",
        }));
        formIsValid = false;
      }
      if (!formData.push_notification_description || formData.push_notification_description.trim() === '') {
        setFormDataError((prevFormData) => ({
          ...prevFormData,
          push_notification_description: "Push notification description cannot be empty.",
        }));
        formIsValid = false;
      }
      if (formData.push_notification_publish_type === "publish_later" && !formData.push_notification_publish_time) {
        setFormDataError((prevFormData) => ({
          ...prevFormData,
          push_notification_publish_time: "Push notification publish time cannot be empty.",
        }));
        formIsValid = false;
      }
    }

    if (formData?.banner === 1) {
      if (!sliderImageFile && (!formData?.Slider_Thumbnail || formData?.Slider_Thumbnail === "" || formData?.Slider_Thumbnail?.includes('default_vertical_image.webp') || formData?.Slider_Thumbnail?.includes('uploads/settings/'))) {
        setFormDataError((prev) => ({
          ...prev,
          slider_image: "Please upload a slider image.",
        }));
        combinedRef.current['slider_image']?.focus();
        formIsValid = false;
      }
    }

    return formIsValid;
  }

  const handleAddScheduleProgram = () => {
    setFormData(prev => ({
      ...prev,
      schedule_programs: [
        ...prev.schedule_programs,
        {
          id: Date.now(),
          name: "",
          description: "",
          start_time: "",
          end_time: "",
          days: "",
          selectedDays: [],
          image: "",
          sort_order: prev.schedule_programs.length
        }
      ]
    }));
  };

  const handleRemoveScheduleProgram = (programId) => {
    setFormData(prev => ({
      ...prev,
      schedule_programs: prev.schedule_programs.filter(p => p.id !== programId)
    }));
    // Also remove from image files if present
    setScheduleImageFiles(prev => {
      const newFiles = { ...prev };
      delete newFiles[programId];
      return newFiles;
    });
  };

  const handleScheduleProgramChange = (programId, field, value) => {
    setFormData(prev => ({
      ...prev,
      schedule_programs: prev.schedule_programs.map(program =>
        program.id === programId ? { ...program, [field]: value } : program
      )
    }));
    // Clear validation error for this field
    setFormDataError(prev => ({
      ...prev,
      [`schedule_program_${programId}_${field}`]: ""
    }));
  };

  const handleScheduleImageChange = async (event, programId) => {
    const { files } = event.target;
    const allowedTypes = ['image/jpeg', 'image/png', 'image/jpg', 'image/webp'];

    if (files?.length > 0) {
      const newFile = files[0];

      if (!allowedTypes.includes(newFile.type)) {
        setFormDataError(prev => ({
          ...prev,
          [`schedule_program_${programId}_image`]: "Only JPG, JPEG, WEBP and PNG files are allowed."
        }));
        return;
      }

      setScheduleImageFiles(prev => ({
        ...prev,
        [programId]: newFile
      }));

      setFormDataError(prev => ({
        ...prev,
        [`schedule_program_${programId}_image`]: ""
      }));
    }
  };

  const handleClearScheduleImage = (programId) => {
    setScheduleImageFiles(prev => {
      const newFiles = { ...prev };
      delete newFiles[programId];
      return newFiles;
    });
    setFormData(prev => ({
      ...prev,
      schedule_programs: prev.schedule_programs.map(program =>
        program.id === programId ? { ...program, image: '' } : program
      )
    }));
  };

  const handleScheduleProgramImageUploads = async (livestreamId) => {
    try {
      // Small delay to ensure DB is updated
      await new Promise(resolve => setTimeout(resolve, 1000));

      const response = await axios.get(`${editApi}/${livestreamId}`, { headers: headers });
      const savedPrograms = response?.data?.data?.schedule_programs || [];

      for (const [frontendProgramId, imageFile] of Object.entries(scheduleImageFiles)) {
        if (imageFile) {
          const programIndex = formData.schedule_programs.findIndex(p => p.id == frontendProgramId);
          const savedProgram = savedPrograms[programIndex];

          if (savedProgram && savedProgram.id) {
            const formDataAdd = new FormData();
            formDataAdd.append('id', savedProgram.id);
            formDataAdd.append('image', imageFile);
            formDataAdd.append('modelName', 'RadioStation'); // Reusing RadioStation model for programs
            formDataAdd.append('imageFields[]', 'image');

            await fetchRequest({ method: 'POST', url: imageApi, data: formDataAdd });
          }
        }
      }
      setScheduleImageFiles({});
    } catch (err) {
      console.error('Error uploading schedule program images:', err);
    }
  };

  const handleFileUpload = async (id, name) => {
    try {
      const formDataAdd = new FormData();
      if (name === 'video-image') {
        formDataAdd.append('id', id);

        const imageFields = [];
        if (coverImageFile) {
          formDataAdd.append('image', coverImageFile);
          imageFields.push('image');
        }
        if (playerImageFile) {
          formDataAdd.append('player_image', playerImageFile);
          imageFields.push('player_image');
        }
        if (tvImageFile) {
          formDataAdd.append('Tv_live_image', tvImageFile);
          imageFields.push('Tv_live_image');
        }
        if (notificationImageFile) {
          formDataAdd.append('notification_image', notificationImageFile);
          imageFields.push('notification_image');
        }
        if (sliderImageFile) {
          formDataAdd.append('slider_image', sliderImageFile);
          imageFields.push('slider_image');
        }

        formDataAdd.append('modelName', 'LiveStream');

        imageFields.forEach((field) => {
          formDataAdd.append('imageFields[]', field);
        });
        const response = await fetchRequest({
          method: 'POST',
          url: `${imageApi}`,
          params: {},
          data: formDataAdd,
        })
        if (response?.data?.status) {
          // toast.success(response?.data?.message)
        }
      }
      if (name == 'live_video') {
        formDataAdd.append('livestream_video', liveVideo)
        const response = await axios.patch(`${liveUploadFile}/${id}`, formDataAdd, { headers: headers });
      }
      setCoverImageFile(null)
      setPlayerImageFile(null)
      setTvImageFile(null)
      setSliderImageFile(null)
      setLiveVideo(null)

    } catch (err) {
      toast.error(err?.response?.data?.message)
    }
  }

  const handleAdd = async (live_id) => {
    const findApi = !id && !live_id && !uploadLiveId ? addApi : `${updateApi}/${(!selectedIds?.length && !live_id && !uploadLiveId) ? id : live_id ? live_id : uploadLiveId} `
    const method = !id && !live_id && !uploadLiveId ? 'POST' : 'PATCH';
    setShowOverlay(true);
    setLoading(true)
    try {
      const formDataAdd = {};
      for (const key in formData) {
        if ([
          "title", "slug", "details", "description", "duration", "year", "rating", "age_restrict",
          "Meta_description", "website_page_title", "website_URL", "url_type", "mp4_url", "embed_url", "m3u_url", "m3u8_url",
          "access", "free_duration_status", "free_duration_time", "featured", "active", "banner", "enable_chats", "enable_live_chat",
          "record_enable", "enable_Tips", "donations_label", "publish_time", "enable_restream", "twitter_streamkey",
          "twitter_restream_url", "fb_streamkey", "fb_restream_url", "youtube_streamkey", "youtube_restream_url",
          "global_ppv", "ppv_price", "ios_ppv_price", "rtmp_url", "pre_ads", "mid_ads_category", "mid_advertisement_sequence_time",
          // include Ideabiz plan ID for live store/update via handleAdd
          "ideabiz_purchase_plans_id",
          "google_product_id_ppvs_id", "streamkey_retain", "brightcove_video_id", "schedule_programs",
          "push_notification_enabled", "push_notification_title", "push_notification_description",
          "push_notification_publish_type", "push_notification_publish_time",
          "source_type", "source_type_name", "slug",
          "content_classification", "is_ads"
        ].includes(key)) {
          if (key === "schedule_programs") {
            formDataAdd[key] = JSON.stringify(formData[key]);
          } else {
            formDataAdd[key] = formData[key]
          }
        }
      }
      if (formData?.url_type == "Encode_stream_video") {
        const matched = formData?.rtmp_type?.find(
          (item) => item?.value === formData?.rtmp_url
        );
        const newHlsUrl = matched?.hls_url || '';

        formDataAdd['hls_url'] = newHlsUrl;
      }
      formDataAdd['artists_id'] = formData?.selected_artists?.map((option) => option?.value).join()
      formDataAdd['category_id'] = formData?.selected_categories?.join()
      formDataAdd['language_id'] = formData?.selected_Languages?.map((option) => option?.value).join()
      formDataAdd['regions_id'] = formData?.selected_Regions?.map((option) => option?.value)
      formDataAdd['block_countries_id'] = formData?.selected_blocked_country?.map((option) => option?.value).join()
      formDataAdd['available_countries_id'] = formData?.selected_available_country?.map((option) => option?.value).join()
      formDataAdd['content_classification'] = formData?.selected_content_classification?.map((option) => option?.value).join()
      formDataAdd['search_tags'] = formData?.search_tags?.join(",")
      formDataAdd['publish_status'] = formData?.publish_type == "publish_now" ? 1 : 0;
      formDataAdd['publish_type'] = formData?.publish_type;
      const response = await axios({ method: method, url: findApi, data: formDataAdd, headers: headers, });
      const result = response?.data;
      if (result?.status) {
        // save custom field values (conditional)
        try {
          const entityId = result?.id || id;
          const { saveCustomFieldsConditional } = await import('../../../CustomFields/conditionalCustomFieldsWrapper');
          const cfRes = await saveCustomFieldsConditional(
            baseURL,
            headers,
            'livestream',
            entityId,
            customFieldValues
          );
          if (!cfRes?.data?.status) throw new Error(cfRes?.data?.message || 'Failed to save additional fields');
        } catch (e) {
          toast.error(e?.response?.data?.message || e.message || 'Failed to save additional fields');
          setShowOverlay(false);
          return;
        }
        // try {
        //   const entityId = result?.id || id;
        //   const cfRes = await axios.post(`${baseURL}/admin/custom-field-values`, { entity_type: 'livestream', entity_id: entityId, values: {} }, { headers });
        //   if (!cfRes?.data?.status) throw new Error(cfRes?.data?.message || 'Failed to save additional fields');
        // } catch (e) {
        //   toast.error(e?.response?.data?.message || e.message || 'Failed to save additional fields');
        //   setShowOverlay(false);
        //   return;
        // }
        // Commit ID - afe64553406c2f887a13b4a0aecd86f3bb7c4488
        if (coverImageFile || playerImageFile || tvImageFile || notificationImageFile) {
          await handleFileUpload(result?.id, 'video-image')
        }

        if (result?.id) {
          await handlePPVPriceStore(result?.id || id)
          await handleScheduleProgramImageUploads(result?.id || id)
        }
        setShowOverlay(false);
        toast.success(result?.message)
        if (!id) {
          navigate("/livestream");
        }
        else {
          setWithOutRefresh(!withOutRefresh)
        }
      }
      else {
        setShowOverlay(false);
        toast.error(result?.message)
      }
    }
    catch (err) {
      setShowOverlay(false);
      const errorMessage = err?.response?.data?.message
      toast.error(errorMessage)
      console.error("error", err)
    } finally {
      setLoading(false)
      setShowOverlay(false)
    }
  }

  const handleStore = async (e) => {
    e.preventDefault()
    if (formValidation()) {
      if (selectedIds?.length) {
        let response_id;
        if (!moveVideo) {
          response_id = await handleMoveVideo(selectedIds);
        }
        return handleAdd(response_id)
      }
      let findLibrary = await uploadingFiles.filter((item) => item?.from == "live")
      if (findLibrary?.length) {
        return handleAdd(findLibrary[findLibrary?.length - 1]?.id)
      }
      return handleAdd()

    }
  }

  const handlePriceModal = () => {
    setPriceModel((prev) => !prev)
  }

  const getDefaultCurrencySetting = () => {
    const dc = defaultOption?.defaultCurrency;
    if (Array.isArray(dc)) return dc?.[0] || {};
    return dc || {};
  }


  const handleCustomizePPVClick = () => {
    const cfg = getDefaultCurrencySetting();
    const isMulti = cfg?.enable_multi_currency == 1;
    const isSec = cfg?.enable_secondary_currency == 1;
    const isSameToggle = cfg?.same_country_toggle == 1;
    if (isMulti || isSec) {
      handlePriceModal();
    } else if (isSameToggle && cfg?.same_currency_country) {
      setSamePriceModel(true);
      if (formData?.ppv_price) {
        handleSameCountryConvert(formData?.ppv_price);
      }
    } else {
      toast.info('Customize PPV is available only in Multi Currency, Secondary Currency, or Same Country mode.');
    }
  }

  const handleSameCountryPriceModalClose = () => {
    setSamePriceModel(false)
  }

  const handlePriceModalClose = async () => {
    setFormData((prev) => ({
      ...prev,
      ppv_price: formData?.ppv_price,
      ios_ppv_price: formData?.ios_ppv_price,
      global_ppv: formData?.global_ppv
    }))
    await handlePriceModal()
    // await handleCovertPrice(editData?.ppv_price)
  }

  const handleSameCountryConvert = async (value) => {
    let formIsValid = true
    if (!formData?.ppv_price || formData?.ppv_price == "0") {
      setFormDataError((prevFormData) => ({
        ...prevFormData,
        ppv_price: "ppv price cannot be empty.",
      }));
      if (combinedRef.current['ppv_price']?.focus) {
        combinedRef.current['ppv_price'].focus()
      }
      formIsValid = false;
    }
    if (formIsValid) {
      const cfg = getDefaultCurrencySetting();
      const baseCode = cfg?.code;
      const baseCountry = cfg?.country;
      const baseSymbol = cfg?.symbol;
      try {
        const response = await axios.get(`${process.env.REACT_APP_API_Curreny_generate}/${baseCode}`);
        const rates = response.data.rates;
        const targetCountryName = cfg?.same_currency_country; // expected 'Dubai'
        const targetRecord = allCurrencylistfromappi?.find(item => (
          item?.country?.toLowerCase() === (targetCountryName || '').toLowerCase()
        ));
        const targetCode = targetRecord?.code;
        const targetSymbol = targetRecord?.Symbol || targetRecord?.symbol;

        const list = [];
        // Base row
        list.push({
          Code: baseCode,
          Country: baseCountry,
          Symbol: baseSymbol,
          ConvertedPriceRate: Number(value).toFixed(2),
          price: value,
          RateDifference: (0).toFixed(2),
          editPrice: Number(value).toFixed(2),
          ChangedPrice: Number(value).toFixed(2),
          isEditable: true,
        });

        if (targetCode && targetCode !== baseCode) {
          const convertedValue = (value * (rates[targetCode] || 0)).toFixed(2);
          list.push({
            Code: targetCode,
            Country: targetCountryName,
            Symbol: targetSymbol,
            ConvertedPriceRate: convertedValue,
            price: value,
            RateDifference: (convertedValue - value).toFixed(2),
            editPrice: convertedValue,
            ChangedPrice: convertedValue,
            isEditable: true,
          });
        }

        setConvertPrice(prevState => ({
          ...prevState,
          source_type: 2,
          PPVType: formData?.global_ppv,
          PriceType: baseCode,
          ActualPrice: value,
          IOSPrice: formData?.ios_ppv_price,
          convertedPriceRates: list
        }));
      } catch (error) {
        console.error('Error fetching currency conversion rates:', error);
      }
    }
  }

  const handleCovertPrice = async (value) => {
    let formIsValid = true
    if (!formData?.ppv_price) {
      setFormDataError((prevFormData) => ({
        ...prevFormData,
        ppv_price: "ppv price cannot be empty.",
      }));
      if (combinedRef.current['ppv_price']) {
        combinedRef.current['ppv_price'].focus()
      }
      formIsValid = false;
    }
    if (formIsValid) {
      const selectedCountryCode = defaultOption?.defaultCurrency?.code
      try {
        const response = await axios.get(`${process.env.REACT_APP_API_Curreny_generate}/${selectedCountryCode}`);
        const rates = response.data.rates;
        let convertedPrices = allCurrencylistfromappi?.map(item => {
          let country_name = item?.country;
          let Symbol = item?.Symbol || item?.symbol;
          let Code = item?.code;

          const matchingCountry = allCurrencylistfromappi.find(currency => currency.code === item?.code);
          if (matchingCountry) {
            country_name = matchingCountry?.country;
            Symbol = matchingCountry?.Symbol || matchingCountry?.symbol;
          }

          return {
            Code: Code,
            Country: country_name,
            Symbol: Symbol,
            ConvertedPriceRate: (value * (rates[item?.code] || 0)).toFixed(2),
            price: value,
            RateDifference: ((value * (rates[item?.code] || 0)) - value).toFixed(2),
            editPrice: (value * (rates[item?.code] || 0)).toFixed(2),
            ChangedPrice: (value * (rates[item?.code] || 0)).toFixed(2),
            isEditable: true,
          };
        });

        const cfg = getDefaultCurrencySetting();
        if (cfg?.enable_secondary_currency == 1 && cfg?.enable_multi_currency != 1) {
          const rawSec = cfg?.secondary_currencies;
          const secCur = (rawSec ? (typeof rawSec === 'string' ? JSON.parse(rawSec) : rawSec) : []) || [];
          const secondaryCodes = secCur.map(c => String(typeof c === 'object' ? (c.short_code || c.value || c.code) : c).toUpperCase());
          convertedPrices = convertedPrices.filter(item => item?.Code && secondaryCodes.includes(String(item.Code).toUpperCase()));
        }

        setConvertPrice(prevState => ({
          ...prevState,
          source_type: 2,
          PPVType: formData?.global_ppv,
          PriceType: selectedCountryCode,
          ActualPrice: value,
          IOSPrice: formData?.ios_ppv_price,
          convertedPriceRates: convertedPrices
        }));
      } catch (error) {
        console.error('Error fetching currency conversion rates:', error);
      }
    }
  };

  const handlePPVPriceStore = async (sourceID) => {
    setShowOverlay(true);
    try {
      // Send PPV conversion data along with Ideabiz plan ID (raw ID)
      const payload = {
        ...convertPrice,
        source_id: sourceID,
        ideabiz_purchase_plans_id: formData?.ideabiz_purchase_plans_id || null,
        google_product_id_ppvs_id: formData?.google_product_id_ppvs_id || null,
      };

      const response = await axios.post(`${updatePPV}`, payload, { headers: headers });
      const result = response?.data
      if (result?.status) {
        setShowOverlay(false);
        setPriceModel(false)
        setSamePriceModel(false)
        // toast.success(result?.message)
      }
      else {
        setShowOverlay(false);
        toast.error(result?.message)
      }
    }
    catch (err) {
      setShowOverlay(false);
      const errorMessage = err?.response?.data?.message
      toast.error(errorMessage)
    }
  }


  const handlePriceChangeInput = (e, index) => {
    const { value } = e.target;
    setConvertPrice(prevState => {
      const updatedRates = [...prevState.convertedPriceRates];
      updatedRates[index] = {
        ...updatedRates[index],
        ConvertedPriceRate: value
      };
      return {
        ...prevState,
        convertedPriceRates: updatedRates
      };
    });
  };


  const handleToggleGalleryModel = (val) => {
    setGalleryModal(prev => !prev)
    if (val == "clear") {
      setSelectedIds([])
    }

  }

  const handleCheckboxChange = (id) => {
    if (id) {
      setSelectedIds((prevSelectedIds) => {
        if (prevSelectedIds?.includes(id)) {
          return [];
        } else {
          return [id];
        }
      });
    }
  };


  const handleMoveVideo = async (library_id) => {
    try {
      const formDataAdd = {};
      let response
      if (!id) {
        formDataAdd['video_ids'] = library_id
        response = await axios.post(`${moveApi}`, formDataAdd, { headers: headers });
        setMoveVideo(true);
      }
      else {
        response = await axios.post(`${assignApi}/?video_id=${id}&library_id=${library_id}&updated_type=video`, {}, { headers: headers });
      }

      const result = response?.data;
      if (result?.status) {
        toast.success(result?.message);
        setSelectedIds(result?.data)
        handleToggleGalleryModel();
        setUploadLiveId(result?.ids?.[0]);
        return result?.ids?.[0] || result?.id
      }
      else {
        toast.error(result?.message)
      }
    }
    catch (err) {
      setShowOverlay(false);
      const errorMessage = err?.response?.data?.message
      toast.error(errorMessage)
      console.error("error", err)
    }

  }

  const handleLibraryChange = async (e, name) => {
    const files = e.target.files;
    if (!files?.length) return;
    const allowedTypes = /video\/(mp4|x-matroska|webm|quicktime|avi)/;
    for (let file of files) {
      if (!allowedTypes.test(file.type)) {
        toast.error(`Unsupported file format: ${file.name}`);
        e.target.value = '';
        return;
      }
    }
    setCheckFileUpload(true);
    const response = await handleFileChangeProvider(e, `${uploadFileApi}${id ? `&action_type=updated&video_id=${id}` : '&action_type=created'}`, "live")
    setUploadLiveId(response[0]?.id);
    console.log("uploadLiveId", response);
  }


  useEffect(() => {
    const loadData = async () => {
      if (id) {
        await fetchData();
      }
      else {
        await fetchCreate()
      }
    };
    loadData();
    labelFetch()
  }, [withOutRefresh]);

  useEffect(() => {
    if (languageModal || artistModal || categoryModal || pricemodel || galleryModal || contentClassificationModal) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = 'auto';
    }
    return () => { document.body.style.overflow = 'auto'; };
  }, [languageModal, artistModal, categoryModal, pricemodel, galleryModal, contentClassificationModal]);




  if (loading) {
    return <Defaultloadinggif className={"heightOnLoader"} />
  }


  const confirmToggle = (suggestedText) => {
    if (suggestedText && typeof suggestedText === 'string' && modalTarget) {
      setFormData(prev => ({ ...prev, [modalTarget]: suggestedText }));
    }
    setShowModal(false);
    setModalTarget(null);
  };

  const handleModal = (target) => {
    setModalTarget(target);
    if (target === "description") {
      setDefaultPrompt(`Give a short description about "${formData?.title || ""}"`);
    } else if (target === "details") {
      setDefaultPrompt(`Expand the content details for "${formData?.title || ""}"`);
    }
    setShowModal(true);
  };

  const generateSuggestion = async (promptText, setSuggestion, setLoading) => {
    const trimmedPrompt = promptText?.trim();
    setLoading(true);
    try {
      const response = await axios.post(
        generateAISuggestionApi,
        { prompt: trimmedPrompt },
        { headers }
      );
      if (response.data?.status) {
        setLoading(false);
        setSuggestion(response.data.response);
      } else {
        alert(response.data.message || "Failed to generate suggestion.");
      }
    } catch (error) {
      if (error.response?.status === 401) {
        alert("Token expired or invalid. Please login again.");
      } else {
        console.error(error);
        alert("Error generating suggestion.");
      }
    }
  };

  function CategoryMultiSelect({ options, value = [], onChange }) {
    const [open, setOpen] = React.useState(false);

    useEffect(() => {
      function handleClickOutside(event) {
        const box = combinedRef.current.category_checkbox;
        if (box && !box.contains(event.target)) {
          setOpen(false);
        }
      }

      document.addEventListener("mousedown", handleClickOutside);
      return () => document.removeEventListener("mousedown", handleClickOutside);
    }, []);

    const toggle = (id) => {
      if (value.includes(id)) {
        onChange(value.filter(v => v !== id));
      } else {
        onChange([...value, id]);
      }
    };

    return (
      <div ref={(el) => (combinedRef.current.category_checkbox = el)} className="relative w-full">

        <div
          className="custom-input-border custom-input theme-text-color cursor-pointer mb-3"
          onClick={(e) => {
            e.stopPropagation();
            setOpen(o => !o);
          }}
        >
          {value.length
            ? `${value.length} categories selected`
            : "Choose categories"}
        </div>

        {open && (
          <div className="absolute bg-white border shadow z-50 mt-1 max-h-80 overflow-auto w-full" >
            <TreeCheckbox
              options={options}
              selected={value}
              onToggle={toggle}
              level={0}
            />
          </div>
        )}
      </div>
    );
  }

  function TreeCheckbox({ options, selected, onToggle, level }) {
    if (!options || !Array.isArray(options)) return null;
    return (
      <ul>
        {options.map(item => (
          <li key={item.id}>
            <label
              className="custom-input theme-text-color d-flex items-center gap-2 py-1 cursor-pointer"
              style={{ paddingLeft: level * 16 }}
            >
              <input
                type="checkbox"
                checked={selected.includes(item.id)}
                onChange={() => onToggle(item.id)}
              />
              {item.name}
            </label>

            {item.sub_category?.length > 0 && (
              <TreeCheckbox
                options={item.sub_category}
                selected={selected}
                onToggle={onToggle}
                level={level + 1}
              />
            )}
            {item.sub_categories?.length > 0 && (
              <TreeCheckbox
                options={item.sub_categories}
                selected={selected}
                onToggle={onToggle}
                level={level + 1}
              />
            )}
          </li>
        ))}
      </ul>
    );
  }

  return (
    <div className="pb-5">
      {/* {showOverlay && (<Response_Processing></Response_Processing>)} */}
      {/* <StorageLimitModal open={showStorageModal} onClose={handleStorageModalClose} /> */}
      {languageModal && (
        <div className={`modal packageModel fade ${languageModal && 'd-block show'}`} id="liveLanguageModal" tabIndex="-1" role="dialog" aria-labelledby="liveLanguageModalLabel" >
          <div className="modal-dialog modal-large" role="document">
            <div className="modal-content theme-bg-color ">
              <div className="modal-header theme-border-bottom-secondary">
                <MessageBox text="Add Language" classname="modal-title theme-text-color admin-modal-title fw-bold" />
                <button type="button" className='bg-transparent theme-text-color' onClick={() => setLanguageModal(false)} aria-label="Close"><IoClose fill='currentColor' style={{ width: "25px", height: "25px" }} /></button>
              </div>
              <div className="modal-body">
                <LanguageAddUpdate isModal={true} forceCreate={true} onSuccess={(newId, newName) => {
                  if (newId && newName) {
                    setDefaultOption(prev => ({
                      ...prev,
                      languageOption: [...(prev?.languageOption || []), { value: newId, label: newName }]
                    }));
                    setFormData(prev => {
                      const curr = Array.isArray(prev?.selected_Languages) ? prev.selected_Languages : [];
                      return { ...prev, selected_Languages: [...curr, { value: newId, label: newName }] };
                    });
                  }
                  setLanguageModal(false);
                }} />
              </div>
            </div>
          </div>
        </div>
      )}
      {artistModal && (
        <div className={`modal packageModel fade ${artistModal && 'd-block show'}`} id="liveArtistModal" tabIndex="-1" role="dialog" aria-labelledby="liveArtistModalLabel" >
          <div className="modal-dialog modal-large" role="document">
            <div className="modal-content theme-bg-color ">
              <div className="modal-header theme-border-bottom-secondary">
                <MessageBox text="Add Artist" classname="modal-title theme-text-color admin-modal-title fw-bold" />
                <button type="button" className='bg-transparent theme-text-color' onClick={() => setArtistModal(false)} aria-label="Close"><IoClose fill='currentColor' style={{ width: "25px", height: "25px" }} /></button>
              </div>
              <div className="modal-body">
                <ArtistAddUpdate isModal={true} forceCreate={true} onSuccess={(newId, newName) => {
                  if (newId && newName) {
                    setDefaultOption(prev => ({
                      ...prev,
                      artistsOption: [...(prev?.artistsOption || []), { value: newId, label: newName }]
                    }));
                    setFormData(prev => {
                      const curr = Array.isArray(prev?.selected_artists) ? prev.selected_artists : [];
                      return { ...prev, selected_artists: [...curr, { value: newId, label: newName }] };
                    });
                  }
                  setArtistModal(false);
                }} />
              </div>
            </div>
          </div>
        </div>
      )}
      {categoryModal && (
        <div className={`modal packageModel fade ${categoryModal && 'd-block show'}`} id="liveCategoryModal" tabIndex="-1" role="dialog" aria-labelledby="liveCategoryModalLabel" >
          <div className="modal-dialog modal-xl" role="document">
            <div className="modal-content theme-bg-color ">
              <div className="modal-header theme-border-bottom-secondary">
                <MessageBox text="Add Category" classname="modal-title theme-text-color admin-modal-title fw-bold" />
                <button type="button" className='bg-transparent theme-text-color' onClick={() => setCategoryModal(false)} aria-label="Close"><IoClose fill='currentColor' style={{ width: "25px", height: "25px" }} /></button>
              </div>
              <div className="modal-body">
                <LiveCategoryAddEdit isModal={true} forceCreate={true} onSuccess={(newId, newName) => {
                  if (newId && newName) {
                    setDefaultOption(prev => ({
                      ...prev,
                      categoryOption: [...(prev?.categoryOption || []), { id: newId, name: newName, sub_category: [] }]
                    }));
                    setFormData(prev => {
                      const curr = Array.isArray(prev?.selected_categories) ? prev.selected_categories : [];
                      return { ...prev, selected_categories: [...curr, newId] };
                    });
                  }
                  setCategoryModal(false);
                }} />
              </div>
            </div>
          </div>
        </div>
      )}
      {contentClassificationModal && (
        <div className={`modal packageModel fade ${contentClassificationModal && 'd-block show'}`} id="liveContentClassificationModal" tabIndex="-1" role="dialog" aria-labelledby="liveContentClassificationModalLabel" >
          <div className="modal-dialog modal-large" role="document">
            <div className="modal-content theme-bg-color ">
              <div className="modal-header theme-border-bottom-secondary">
                <MessageBox text="Add Content Classification" classname="modal-title theme-text-color admin-modal-title fw-bold" />
                <button type="button" className='bg-transparent theme-text-color' onClick={() => setContentClassificationModal(false)} aria-label="Close"><IoClose fill='currentColor' style={{ width: "25px", height: "25px" }} /></button>
              </div>
              <div className="modal-body">
                <ContentClassification isModal={true} onSuccess={(newTitle) => {
                  if (newTitle) {
                    setDefaultOption(prev => ({
                      ...prev,
                      contentClassificationOption: [...(prev?.contentClassificationOption || []), { value: newTitle, label: newTitle }]
                    }));
                    setFormData(prev => {
                      const curr = Array.isArray(prev?.selected_content_classification) ? prev.selected_content_classification : [];
                      return { ...prev, selected_content_classification: [...curr, { value: newTitle, label: newTitle }] };
                    });
                  }
                  setContentClassificationModal(false);
                }} />
              </div>
            </div>
          </div>
        </div>
      )}
      {galleryModal && <AdminGalleryModal modelClose={galleryModal} closeAction={handleToggleGalleryModel} sourceType={1} saveAction={handleMoveVideo} changeAction={handleCheckboxChange} selectedIds={selectedIds} buttonText={"Select Video"} />}
      {pricemodel &&
        <div class={`modal  packageModel fade ${pricemodel && 'd-block show'}`} id="exampleModal" tabIndex="-1" role="dialog" aria-labelledby="exampleModalLabel" >
          <div className="modal-dialog modal-large" role="document">
            <div className="modal-content  theme-bg-color ">
              <div className="modal-header theme-border-bottom-secondary">
                <MessageBox text="Price exchange" classname="modal-title theme-text-color admin-modal-title fw-bold" />
                <button id="ppvCloseModelUp" type="button" className='bg-transparent theme-text-color' onClick={handlePriceModalClose} ><IoClose fill='currentColor' style={{ width: "25px", height: "25px" }} /></button>
              </div>
              <div className="modal-body">
                {/* <div className="d-flex justify-content-between mb-2 col-8 me-auto">
                  <div className="col-12 col-md-6 pe-2">
                    <MessageSubHeading text={labelDisplay?.[61]?.sub_title} />
                  </div>
                  <div className="col-12 col-md-6 ps-2 text-end">
                    <AdminSwitch id="globalPPVCheckbox" name={'global_ppv'} checked={formData?.global_ppv == 1} onChange={handleInput} />
                  </div>
                </div> */}

                <div className="row mx-0 align-items-start mb-3 ">
                  <div className="col-12 col-md-5 ps-0 ">
                    <MessageLabel text={`${formData?.global_ppv == 0 ? labelDisplay?.[60]?.title : labelDisplay?.[59]?.title}  (${defaultOption?.defaultCurrency?.symbol} ${defaultOption?.defaultCurrency?.code}) - ${defaultOption?.defaultCurrency?.country}`} />
                    <AdminCustomInput isReadonly={formData?.global_ppv == 1} type="number" id="countryPPVPrice" name="ppv_price" value={formData?.ppv_price} onChange={handleInput} placeHolder={"Please enter ppv price"} ref={(el) => (combinedRef.current.ppv_price = el)} error={formDataError?.ppv_price} />
                  </div>
                  <div className="col-12 col-md-5 ">
                    <MessageLabel text={`${labelDisplay?.[62]?.title}  (${defaultOption?.defaultCurrency?.symbol} ${defaultOption?.defaultCurrency?.code}) - ${defaultOption?.defaultCurrency?.country}`} />
                    <AdminCustomSelect id={"countryPPVIOSPrice"} name="ios_ppv_price" value={formData?.ios_ppv_price || 0} onChange={handleInput} ref={(el) => (combinedRef.current.ios_ppv_price = el)} options={defaultOption?.iosOption?.map((item) => ({ name: item?.plan_price, value: item?.id }))} error={formDataError?.ios_ppv_price} defaultOptionName={"Choose an ios price"} />
                  </div>
                  {/* Ideabiz Purchase Plan - only when data is present */}
                  {Array.isArray(defaultOption?.ideabizPPVPurchase) && defaultOption.ideabizPPVPurchase.length > 0 && (
                    <div className="col-12 col-md-5 mt-3 ps-0 ">
                      <MessageLabel text="Idea Biz Purchase" />
                      <AdminCustomSelect
                        id="live-ideabiz-purchase-plans"
                        name="ideabiz_purchase_plans_id"
                        // Now storing only the raw ID for ideabiz_purchase_plans_id
                        value={formData?.ideabiz_purchase_plans_id || ''}
                        onChange={(e) => {
                          const planId = e.target.value;
                          setFormData(prev => ({
                            ...prev,
                            ideabiz_purchase_plans_id: planId ? parseInt(planId) : null,
                          }));
                        }}
                        options={defaultOption.ideabizPPVPurchase.map(plan => ({
                          name: plan?.plan_name || plan?.name || `Plan ${plan?.id}`,
                          value: plan?.id,
                        }))}
                        defaultOptionName="Choose Idea Biz plan"
                      />
                    </div>
                  )}
                  {Array.isArray(defaultOption?.googleProductIdPPV) && defaultOption.googleProductIdPPV.length > 0 && (
                    <div className="col-12 col-md-5 mt-3 ps-0 ">
                      <MessageLabel text="Google Purchase" />
                      <AdminCustomSelect
                        id="live-google-product-ppvs"
                        name="google_product_id_ppvs_id"
                        value={formData?.google_product_id_ppvs_id || ''}
                        onChange={(e) => {
                          const planId = e.target.value;
                          setFormData(prev => ({
                            ...prev,
                            google_product_id_ppvs_id: planId ? parseInt(planId) : null,
                          }));
                        }}
                        options={defaultOption.googleProductIdPPV.map(plan => ({
                          name: plan?.product_id || plan?.name || `Product ${plan?.id}`,
                          value: plan?.id,
                        }))}
                        defaultOptionName="Choose Google Purchase"
                      />
                    </div>
                  )}
                  <div className="col-12 col-md-2 pe-0 align-self-center mt-4">
                    <AdminCustomButton id="covertPriceButton" className='px-3 py-1 m-0' saveMethod={() => handleCovertPrice(formData?.ppv_price)} saveText='Convert' />
                  </div>
                </div>
                <div className="priceTable rounded-3  ">
                  <table class="table rounded-3  position-relative">
                    <thead className="theme-bg-color-secondary  z-index-1">
                      <tr>
                        <th scope="col" className="theme-bg-color-secondary border-0 py-sm-3">Country</th>
                        <th scope="col" className="theme-bg-color-secondary border-0 py-sm-3">Current Price</th>
                        <th scope="col" className="theme-bg-color-secondary border-0 py-sm-3">Converted Price</th>
                        {/* <th scope="col">Converted IOS Price</th> */}
                        <th scope="col" className="theme-bg-color-secondary border-0 py-sm-3">Difference</th>
                      </tr>
                    </thead>
                    <tbody>
                      {convertPrice?.convertedPriceRates?.length ? convertPrice?.convertedPriceRates.map((item, index) => (
                        <tr key={index}>
                          <td className="" scope="row">{`${item?.Country} (${item?.Code})`}</td>
                          <td className="">{item.Symbol} {item?.price || item?.ActualPrice}</td>
                          <td className=""> <AdminCustomInput id="priceChangeInput" isReadonly={formData?.global_ppv == 1} type="text" name="price" value={item?.ConvertedPriceRate} onChange={(e) => handlePriceChangeInput(e, index)} placeHolder={"Fill the custom price"} noMargin noBorder={formData?.global_ppv == 1} className={`${formData?.global_ppv == 1 && 'border-0'}`} /> </td>
                          <td className="">{item?.RateDifference}</td>
                        </tr>
                      )) :
                        <tr>
                          <td colSpan={4} className="errorred text-center">* Please update the pricing according to the specific market in each currency !.</td>
                        </tr>}
                    </tbody>
                  </table>
                </div>
              </div>
              <div className="modal-footer  border-0">
                <button id="ppvCloseModelDown" type="button" className="bg-transparent theme-text-color sliderBtnText px-2" onClick={handlePriceModalClose} ><MessageBox text="Cancel" /> </button>
                <AdminCustomButton id="countryPriceSubmitButton" className='px-3 py-1 m-0 ' saveMethod={handlePriceModal} saveText='Done' />
              </div>
            </div>
          </div>
        </div>}
      {samePriceModel &&
        <div className={`modal packageModel fade ${samePriceModel && 'd-block show'}`} id="sameCountryModal" tabIndex="-1" role="dialog" aria-labelledby="sameCountryModalLabel" >
          <div className="modal-dialog modal-large" role="document">
            <div className="modal-content theme-bg-color ">
              <div className="modal-header theme-border-bottom-secondary">
                <MessageBox text="Same Country Price exchange" classname="modal-title theme-text-color admin-modal-title fw-bold" />
                <button id="samePpvCloseModelUp" type="button" className='bg-transparent theme-text-color' onClick={handleSameCountryPriceModalClose} ><IoClose fill='currentColor' style={{ width: "25px", height: "25px" }} /></button>
              </div>
              <div className="modal-body">
                <div className="row mx-0 align-items-start mb-3 ">
                  <div className="col-12 col-md-5 ps-0 ">
                    <MessageLabel text={`Price (${defaultOption?.defaultCurrency?.symbol} ${defaultOption?.defaultCurrency?.code}) - ${defaultOption?.defaultCurrency?.country}`} />
                    <AdminCustomInput type="number" id="sameCountryPPVPrice" name="ppv_price" value={formData?.ppv_price} onChange={handleInput} placeHolder={"Please enter ppv price"} ref={(el) => (combinedRef.current.ppv_price = el)} error={formDataError?.ppv_price} />
                  </div>
                  <div className="col-12 col-md-5 ">
                    <MessageLabel text={`IOS Price (${defaultOption?.defaultCurrency?.symbol} ${defaultOption?.defaultCurrency?.code}) - ${defaultOption?.defaultCurrency?.country}`} />
                    <AdminCustomSelect id={"sameCountryPPVIOSPrice"} name="ios_ppv_price" value={formData?.ios_ppv_price || 0} onChange={handleInput} ref={(el) => (combinedRef.current.ios_ppv_price = el)} options={defaultOption?.iosOption?.map((item) => ({ name: item?.plan_price, value: item?.id }))} error={formDataError?.ios_ppv_price} defaultOptionName={"Choose an ios price"} />
                  </div>
                  <div className="col-12 col-md-2 pe-0 align-self-center mt-4">
                    <AdminCustomButton id="covertSamePriceButton" className='px-3 py-1 m-0' saveMethod={() => handleSameCountryConvert(formData?.ppv_price)} saveText='Convert' />
                  </div>
                </div>
                <div className="priceTable rounded-3">
                  <table className="table rounded-3 position-relative">
                    <thead className="theme-bg-color-secondary z-index-1">
                      <tr>
                        <th scope="col" className="theme-bg-color-secondary border-0 py-sm-3">Country</th>
                        <th scope="col" className="theme-bg-color-secondary border-0 py-sm-3">Current Price</th>
                        <th scope="col" className="theme-bg-color-secondary border-0 py-sm-3">Converted Price</th>
                        <th scope="col" className="theme-bg-color-secondary border-0 py-sm-3">Difference</th>
                      </tr>
                    </thead>
                    <tbody>
                      {convertPrice?.convertedPriceRates?.length ? convertPrice?.convertedPriceRates.map((item, index) => (
                        <tr key={index}>
                          <td className="" scope="row">{`${item?.Country} (${item?.Code})`}</td>
                          <td className="">{item.Symbol} {item?.price || item?.ActualPrice}</td>
                          <td className="">
                            <AdminCustomInput id="samePriceChangeInput" type="text" name="price" value={item?.ConvertedPriceRate} onChange={(e) => handlePriceChangeInput(e, index)} placeHolder={"Fill the custom price"} noMargin />
                          </td>
                          <td className="">{item?.RateDifference}</td>
                        </tr>
                      )) :
                        <tr>
                          <td colSpan={4} className="errorred text-center">* Please update the pricing according to the specific market in each currency !.</td>
                        </tr>}
                    </tbody>
                  </table>
                </div>
              </div>
              <div className="modal-footer border-0">
                <button id="samePpvCloseModelDown" type="button" className="bg-transparent theme-text-color sliderBtnText px-2" onClick={handleSameCountryPriceModalClose} ><MessageBox text="Cancel" /> </button>
                <AdminCustomButton id="sameCountryPriceSubmitButton" className='px-3 py-1 m-0 ' saveMethod={handleSameCountryPriceModalClose} saveText='Done' />
              </div>
            </div>
          </div>
        </div>
      }
      <AdminBackNavigation path={`/livestream`} text="Back" />

      {id != null ?
        <AdminSaveHeader loading={loading} heading={!id ? labelDisplay?.[0]?.title : labelDisplay?.[58]?.title} saveText={!id ? labelDisplay?.[57]?.title : labelDisplay?.[57]?.title} saveMethod={handleStore} id={"live-preview-button"} link={navigateChecker(languageCodeData, siteTheme, `live/${formData.slug}`)} />
        : <AdminSaveHeader loading={loading} heading={!id ? labelDisplay?.[0]?.title : labelDisplay?.[58]?.title} saveText={!id ? labelDisplay?.[57]?.title : labelDisplay?.[57]?.title} saveMethod={handleStore} id={"live-store-button"} />
      }

      <FormContainer>
        <LeftWrapper>
          <Wrapper>
            <MessageHeading text={!id ? labelDisplay?.[1]?.title : formData?.title} />
            <MessageLabel text={labelDisplay?.[2]?.title} className="mandatorySimple" />
            <MessageSubHeading text={labelDisplay?.[2]?.sub_title} />
            <AdminCustomInput id={"live-title"} type="text" name="title" value={formData?.title} onChange={handleInput} placeHolder={"Title"} ref={(el) => (combinedRef.current.title = el)} onBlur={handleBlurtitle} onKeyDown={handleInputKeyDowntitle} error={formDataError?.title} />

            <MessageLabel text={labelDisplay?.[3]?.title} className="mandatorySimple" />
            <MessageSubHeading text={labelDisplay?.[3]?.sub_title} />
            <AdminCustomInput id={"live-slug"} type="text" name="slug" value={formData?.slug} ref={(el) => (combinedRef.current.slug = el)} onChange={handleInput} placeHolder={"Slug"} error={formDataError?.slug} />

            {showModal && (<AdminAIModal modalDescription="Suggest AI" modalHeading="Generate Content" modelClose={showModal} sliderClose={closeModal} applySuggestion={confirmToggle} generateSuggestion={generateSuggestion} defaultPrompt={defaultPrompt} />)}
            <MessageLabel text={labelDisplay?.[4]?.title} enableAI handleAIModal={() => handleModal("description")} />
            <MessageSubHeading text={labelDisplay?.[4]?.sub_title} />
            <AdminCustomArea id={"live-description"} type="text" name="description" value={formData?.description} onChange={handleInput} ref={(el) => (combinedRef.current.description = el)} placeHolder={"description"} rows={5} maxLength={"250"} />

            <MessageLabel text={labelDisplay?.[5]?.title} enableAI handleAIModal={() => handleModal("details")} />
            <MessageSubHeading text={labelDisplay?.[5]?.sub_title} />
            <JoditEditor id={"live-details"} className="mb-3" ref={(el) => (combinedRef.current.details = el)} value={formData?.details} onChange={(newContent) => setFormData(prev => ({ ...prev, details: newContent }))} />

            {customFieldValues?.length > 0 && (


              <div className="card p-3 mt-3">
                {/* <MessageHeading text="Additional Fields" /> */}
                {/* Custom fields */}
                <FieldRenderer2
                  pageIdentifier={id ? "livestream.edit" : "livestream.create"}
                  entityType={"livestream"}
                  entityId={id}
                  text="Additional Fields"
                />
                <FieldRenderer
                  pageIdentifier={id ? "livestream.edit" : "livestream.create"}
                  entityType={"livestream"}
                  entityId={id}
                  onChange={setCustomFieldValues}
                />


              </div>


            )}

          </Wrapper>

          <Wrapper>
            <MessageHeading text={labelDisplay?.[8]?.title} />

            <div className="d-flex justify-content-between align-items-start">
              <div className="pe-2">
                <MessageLabel text={labelDisplay?.[12]?.title} className="mandatorySimple" />
                <MessageSubHeading text={labelDisplay?.[12]?.sub_title} />
              </div>
              <button type="button" id="live-category-add-button" className="vjs-big-play-button rounded" onClick={() => setCategoryModal(true)} title="Add Category">
                < MdAddCircle style={{ width: "20px", height: "20px" }} />
              </button>
            </div>
            <CategoryMultiSelect
              options={defaultOption?.categoryOption}
              value={formData.selected_categories || []}
              onChange={(vals) => setFormData(p => ({ ...p, selected_categories: vals }))}
              name={"selected_categories"}
            />
            {formDataError?.selected_categories && (<MessageBox text={`${formDataError?.selected_categories}`} classname='errorred mb-2 d-block' />)}

            <MessageLabel text={labelDisplay?.[10]?.title} className="mandatorySimple" />
            <MessageSubHeading text={labelDisplay?.[10]?.sub_title} />
            <AdminCustomSelect id={"live-age_restrict"} name="age_restrict" value={formData?.age_restrict} onChange={handleInput} ref={(el) => (combinedRef.current.age_restrict = el)} options={defaultOption?.ageOption?.map((item) => ({ name: item?.age, value: item?.age }))} error={formDataError?.age_restrict} defaultOptionName={"Choose an age"} />
            <div className="d-flex justify-content-between align-items-start">
              <div className="pe-2">
                <MessageLabel text={"Content Classification"} />
                <MessageSubHeading text={"Select the content classification"} />
              </div>
              <button type="button" id="live-content-classification-add-button" className="vjs-big-play-button rounded" onClick={() => setContentClassificationModal(true)} title="Add Content Classification">
                <MdAddCircle style={{ width: "20px", height: "20px" }} />
              </button>
            </div>
            <Select id={"live-content-classification"} options={defaultOption?.contentClassificationOption} isMulti name={'selected_content_classification'} onChange={handleMultiSelect} value={formData?.selected_content_classification} className="custom-select-multi custom-placeholder theme-text-color mb-3" />

            <div className="d-flex justify-content-between align-items-start">
              <div className="pe-2">
                <MessageLabel text={labelDisplay?.[13]?.title} />
                <MessageSubHeading text={labelDisplay?.[13]?.sub_title} />
              </div>
              <button type="button" id="live-language-add-button" className="vjs-big-play-button rounded" onClick={() => setLanguageModal(true)} title="Add Language">
                < MdAddCircle style={{ width: "20px", height: "20px" }} />
              </button>
            </div>
            <Select id={"live-language"} options={defaultOption?.languageOption} isMulti name={'selected_Languages'} onChange={handleMultiSelect} value={formData?.selected_Languages} className="custom-select-multi custom-placeholder theme-text-color mb-3" />

            {onlyPermission?.includes(47) && (
              <>
                <MessageLabel text={"Region"} />
                <MessageSubHeading text={"Add Region for the Live Stream below"} />
                <Select id={"live-region"} options={defaultOption?.regionOption} isMulti name={'selected_Regions'} onChange={handleMultiSelect} value={formData?.selected_Regions} className="custom-select-multi custom-placeholder theme-text-color mb-3" />
              </>
            )}

            <div className="d-flex justify-content-between align-items-start">
              <div className="pe-2">
                <MessageLabel text={labelDisplay?.[11]?.title} />
                <MessageSubHeading text={labelDisplay?.[11]?.sub_title} />
              </div>
              <button type="button" id="live-artist-add-button" className="vjs-big-play-button rounded" onClick={() => setArtistModal(true)} title="Add Artist">
                < MdAddCircle style={{ width: "20px", height: "20px" }} />
              </button>
            </div>
            <Select id={"live-artist"} options={defaultOption?.artistsOption} isMulti name={'selected_artists'} onChange={handleMultiSelect} value={formData?.selected_artists} className="custom-select-multi custom-placeholder theme-text-color mb-3" />

            <MessageLabel text={labelDisplay?.[9]?.title} />
            <MessageSubHeading text={labelDisplay?.[9]?.sub_title} />
            <AdminCustomSelect id={"live-rating"} name="rating" value={formData?.rating} onChange={handleInput} ref={(el) => (combinedRef.current.rating = el)} options={Array.from({ length: 10 })?.map((item, index) => ({ name: index + 1, value: index + 1 }))} error={formDataError?.rating} defaultOptionName={"Choose an rating"} />
          </Wrapper>


          <Wrapper>
            <MessageHeading text={labelDisplay?.[44]?.title} />

            <MessageLabel text={labelDisplay?.[6]?.title} />
            <MessageSubHeading text={labelDisplay?.[6]?.sub_title} />
            <AdminCustomInput id={"live-duration"} type="text" maxLength="6" name="duration" value={formData?.duration} ref={(el) => (combinedRef.current.duration = el)} onChange={handleInput} placeHolder={"HH:MM:SS"} error={formDataError?.duration} />

            {formData?.url_type !== "embed_url" && (
              <>
                <div className="d-flex justify-content-between mb-2 mt-3">
                  <div className="col-6 col-md-6 pe-2">
                    <MessageLabel text={labelDisplay?.[45]?.title} className={formData?.free_duration_status ? "mandatorySimple" : ""} />
                  </div>
                  <div className="col-6 col-md-6 ps-2 text-end">
                    <AdminSwitch id={"live-free-duration-status"} name="free_duration_status" checked={formData?.free_duration_status} onChange={handleInput} />
                  </div>
                </div>

                {formData?.free_duration_status == 1 && <>
                  <MessageLabel text={labelDisplay?.[46]?.title} />
                  <MessageSubHeading text={labelDisplay?.[46]?.sub_title} />
                  <AdminCustomInput id={"live-free-duration-time"} ref={(el) => (combinedRef.current.free_duration_time = el)} type="text" maxLength="6" name="free_duration_time" value={formData?.free_duration_time} onChange={handleInput} placeHolder={"HH:MM:SS"} error={formDataError?.free_duration_time} />
                </>}
              </>
            )}

          </Wrapper>

          {(getGeofencing === "ON" || getGeofencingAvailableCountries === 1) && (
            <Wrapper>
              <MessageHeading text={"Geo-Fencing"} />
              {getGeofencing === "ON" && (
                <>
                  <MessageLabel text={labelDisplay?.[14]?.title} />
                  <MessageSubHeading text={labelDisplay?.[14]?.sub_title} />
                  <Select
                    id="live-blockCountry"
                    options={defaultOption?.blockCountryOption?.filter(
                      (blockedItem) => !formData?.selected_available_country?.some(
                        (availableItem) => availableItem?.value === blockedItem?.value
                      )
                    )}
                    isMulti
                    name="selected_blocked_country"
                    onChange={handleMultiSelect}
                    value={formData?.selected_blocked_country}
                    className="custom-select-multi custom-placeholder theme-text-color mb-3"
                  />
                </>
              )}

              {getGeofencingAvailableCountries === 1 && (
                <>
                  <MessageLabel text={labelDisplay?.[15]?.title} />
                  <MessageSubHeading text={labelDisplay?.[15]?.sub_title} />
                  <Select
                    id="live-availableCountry"
                    options={defaultOption?.availableCountryOption?.filter(
                      (AvailableItem) => !formData?.selected_blocked_country?.some(
                        (blockedItem) => blockedItem?.value === AvailableItem?.value
                      )
                    )}
                    isMulti
                    name="selected_available_country"
                    onChange={handleMultiSelect}
                    value={formData?.selected_available_country}
                    className="custom-select-multi custom-placeholder theme-text-color mb-3"
                  />
                </>
              )}
            </Wrapper>
          )}

          <Wrapper>
            <MessageHeading text={labelDisplay?.[55]?.title} />
            <MessageLabel text={labelDisplay?.[56]?.title} />
            <MessageSubHeading text={labelDisplay?.[56]?.sub_title} />
            <TagsInput id={"live-searchTags"} name="search_tags" value={formData?.search_tags} separators={["Enter", ","]} classNames={{ tag: "custom-search-tag", input: "w-100" }} onChange={handleTagsChange} />
          </Wrapper>

          <Wrapper>
            <MessageHeading text={labelDisplay?.[47]?.title} />
            <div className="d-flex justify-content-between mb-2 ">
              <div className="col-6 col-md-6 pe-2">
                <MessageLabel text={labelDisplay?.[48]?.title} />
              </div>
              <div className="col-6 col-md-6 ps-2 text-end">
                <AdminSwitch id={"live-featured"} name={'featured'} checked={formData?.featured == 1} onChange={handleInput} />
              </div>
            </div>

            <div className="d-flex justify-content-between mb-2 ">
              <div className="col-6 col-md-6 pe-2">
                <MessageLabel text={labelDisplay?.[49]?.title} />
              </div>
              <div className="col-6 col-md-6 ps-2 text-end">
                <AdminSwitch id={"live-active"} name={'active'} checked={formData?.active == 1} onChange={handleInput} />
              </div>
            </div>
            {onlyPermission?.includes(53) && (
              <div className="d-flex justify-content-between mb-2 ">
                <div className="col-6 col-md-6 pe-2">
                  <MessageLabel text={"Enable Live Chat"} />
                </div>
                <div className="col-6 col-md-6 ps-2 text-end">
                  <AdminSwitch id={"live-chat-enable"} name={'enable_live_chat'} checked={formData?.enable_live_chat == 1} onChange={handleInput} />
                </div>
              </div>
            )}
            <div className="d-flex justify-content-between mb-2 ">
              <div className="col-6 col-md-6 pe-2">
                <MessageLabel text={"Enable as Slider"} />
              </div>
              <div className="col-6 col-md-6 ps-2 text-end">
                <AdminSwitch id={"live-banner"} name={'banner'} checked={formData?.banner == 1} onChange={handleInput} />
              </div>
            </div>
            {formData?.banner === 1 && (
              <>
                <MessageLabel text="Slider Image" className={`${formData?.banner === 1 ? 'mandatorySimple' : ''}`} />
                <MessageSubHeading text="Resolution 3840*1440 and Ratio 8:3" />
                <AdminImageUploadZone
                  idAttribute={`live-slider-image-${id}`}
                  onChange={handleFileChange}
                  selectedFile={sliderImageFile}
                  uploadedImage={formData?.Slider_Thumbnail}
                  onDelete={handleClearSelectFile}
                  ref={(el) => (combinedRef.current.slider_image = el)}
                  name="slider_image"
                  apiFieldName="slider_image"
                  error={formDataError?.slider_image}
                  id={id}
                />
              </>
            )}
            {(onlyPermission?.includes(48)) && (
              <div className="d-flex justify-content-between mb-2 ">
                <div className="col-6 col-md-6 pe-2">
                  <MessageLabel text={"Promote as Advertisement"} />
                </div>
                <div className="col-6 col-md-6 ps-2 text-end">
                  <AdminSwitch id={"live-is-ads"} name={'is_ads'} checked={formData?.is_ads == 1} onChange={handleInput} />
                </div>
              </div>
            )}
            {/* <div className="d-flex justify-content-between mb-2 ">
                <div className="col-6 col-md-6 pe-2">
                  <MessageLabel text='Enable record' />
                </div>
                <div className="col-6 col-md-6 ps-2 text-end">
                  <AdminSwitch id={"live-record"} name={'record_enable'} checked={formData?.record_enable == 1} onChange={handleInput} />
                </div>
              </div> */}
            {/* <div className="d-flex justify-content-between mb-2 ">
                <div className="col-6 col-md-6 pe-2">
                  <MessageLabel text={labelDisplay?.[51]?.title} />
                </div>
                <div className="col-6 col-md-6 ps-2 text-end">
                  <AdminSwitch id={"live-enable-chats"} name={'enable_chats'} checked={formData?.enable_chats == 1} onChange={handleInput} />
                </div>
              </div> */}
          </Wrapper>
          {/* <Wrapper>
            <MessageHeading text="Advertisement" />
            <MessageLabel text="Choose the Pre Position Advertisement" />
            <AdminCustomSelect name="pre_ads" onChange={handleInput} value={formData?.pre_ads} options={defaultOption?.preAdvertisement?.map((item) => ({value: item?.id, name: item?.ads_name}))} defaultOptionName={"Select pre ad"} /> */}
          {/* Second Row: Mid Ads Category & Sequence */}
          {/* <div className="row">
              <div className="col-md-6 mb-3">
                <MessageLabel text="Choose the Mid Category Advertisement" />
                <AdminCustomSelect name="mid_ads_category" onChange={handleInput} value={formData?.mid_ads_category} options={defaultOption?.midAdsCategory?.map((item) => ({value: item?.id, name: item?.name}))} defaultOptionName={"Select mid ad category"} />
              </div>

              <div className="col-md-6 mb-3">
                <MessageLabel text="Mid Advertisement Sequence Time" className={`${!formData?.mid_ads_category ? "" : "mandatorySimple"}`} />
                <AdminCustomInput
                  id="video-category-sequence"
                  data-test-id="video-category-sequence"
                  type="text"
                  ref={(el) => (combinedRef.current.mid_advertisement_sequence_time = el)}
                  name="mid_advertisement_sequence_time"
                  value={formData?.mid_advertisement_sequence_time}
                  onChange={handleInput}
                  placeHolder={"HH:MM:SS"}
                  error={formDataError?.mid_advertisement_sequence_time}
                  maxLength={"6"}
                />
              </div>
            </div> */}
          {/* </Wrapper> */}

        </LeftWrapper>
        <RightWrapper>

          {formData?.video_format_type ?
            <Wrapper style={{ height: '85vh' }}>
              <MessageLabel text={`Active Live Type : ${formData?.url_type?.replace(/_/g, " ") == "transcoding video" || formData?.url_type?.replace(/_/g, " ") == "m3u8 url" ? "HLS" : formData?.url_type?.replace(/_/g, " ")}`} className={"mb-sm-3"} />
              <div className="adminVideoPlayer playerHeight vjs-16-9">
                {
                  formData?.video_format_type == "embed" ? <AdminYoutubePlayer id={"live-embedVideo"} src={formData?.video_url} /> :
                    (formData?.url_type == "transcoding_video" && !formData?.m3u8_url)
                      ? <AdminProcessButton cell={formData.draft == 0 ? "PROCESS" : formData.active == 1 && formData.status == 1 ? "PUBLISHED" : "UNPUBLISHED"} row={{ ...formData }} />
                      : <AdminMiniPlayer url={formData?.video_url || formData?.mp4_url || formData?.m3u8_url} videoFormat={formData?.video_format_type} title={formData?.title} poster={formData?.player_image} className="playerHeight" />
                }
              </div>
            </Wrapper>
            : ""}

          <Wrapper>
            <MessageHeading text={labelDisplay?.[20]?.title} />
            <MessageLabel text={labelDisplay?.[21]?.title} className={`${imagerequiredValidation?.live === 1 ? "mandatorySimple" : ""}`} />
            <MessageSubHeading text={buildDynamicSubText(labelDisplay?.[21]?.sub_title, 'portrait')} />
            <AdminImageUploadZone
              onChange={handleFileChange}
              selectedFile={coverImageFile}
              uploadedImage={formData?.image}
              onDelete={handleClearSelectFile}
              ref={(el) => (combinedRef.current.image = el)}
              name="image"
              orientationSlug="portrait"
              id={"live-cover-image"}
              error={formDataError?.image}
            />
            <MessageLabel text={labelDisplay?.[22]?.title} className={`${imagerequiredValidation?.live === 1 ? "mandatorySimple" : ""}`} />
            <MessageSubHeading text={buildDynamicSubText(labelDisplay?.[22]?.sub_title, 'landscape')} />
            <AdminImageUploadZone
              onChange={handleFileChange}
              selectedFile={playerImageFile}
              uploadedImage={formData?.player_image}
              onDelete={handleClearSelectFile}
              ref={(el) => (combinedRef.current.player = el)}
              name="player"
              orientationSlug="landscape"
              id={"live-player-image"}
              error={formDataError?.player}

            />
            <MessageLabel text={labelDisplay?.[23]?.title} className={`${imagerequiredValidation?.live === 1 ? "mandatorySimple" : ""}`} />
            <MessageSubHeading text={buildDynamicSubText(labelDisplay?.[23]?.sub_title, 'landscape')} />
            <AdminImageUploadZone
              onChange={handleFileChange}
              selectedFile={tvImageFile}
              uploadedImage={formData?.Tv_live_image}
              onDelete={handleClearSelectFile}
              ref={(el) => (combinedRef.current.tv = el)}
              name="tv"
              orientationSlug="landscape"
              error={formDataError?.tv}
              id={"live-tv-image"}
            />

          </Wrapper>

          <Wrapper>
            <MessageHeading text={labelDisplay?.[24]?.title} />
            <MessageLabel text={labelDisplay?.[25]?.title} className="mandatorySimple" />
            <MessageSubHeading text={labelDisplay?.[25]?.sub_title} />
            <AdminCustomSelect ref={(el) => (combinedRef.current.url_type = el)} name="url_type" value={formData?.url_type} defaultValue={formData?.url_type} onChange={handleInput}
              options={defaultOption?.liveSourceOption
                ?.filter((item) => item?.value !== "Encode_stream_video" || (item?.Rtmp_urls && item?.Rtmp_urls.length > 0)
                )?.map((item) => {
                  const optionData = {
                    value: item?.value,
                    name: item?.name,
                    rtmpUrls: item?.Rtmp_urls?.map((rtmp) => ({
                      id: rtmp?.id,
                      name: `Streaming Video ${rtmp?.id}`,
                    })),
                  };
                  return optionData;
                })}
              error={formDataError?.url_type} defaultOptionName={"Choose Live Source"} label={"name"} id={"live-url-type"} />
            {formData?.url_type == "mp4_url" && <AdminCustomInput id={"live-mp4-url"} type="text" name="mp4_url" value={formData?.mp4_url} ref={(el) => (combinedRef.current.mp4_url = el)} onChange={handleInput} placeHolder={"Please enter mp4 url"} error={formDataError?.mp4_url} />}
            {formData?.url_type == "brightcove" && <AdminCustomInput id={"live-brightcove-video-id"} type="text" name="brightcove_video_id" value={formData?.brightcove_video_id} ref={(el) => (combinedRef.current.brightcove_video_id = el)} onChange={handleInput} placeHolder={"Please enter Brightcove Video ID"} error={formDataError?.brightcove_video_id} />}
            {formData?.url_type == "embed_url" && <AdminCustomInput id={"live-embed-url"} type="text" name="embed_url" value={formData?.embed_url} ref={(el) => (combinedRef.current.embed_url = el)} onChange={handleInput} placeHolder={"Please enter embed url"} error={formDataError?.embed_url} />}
            {selectedIds?.length ? <MessageLabel text={"Your are choosed video form library"} /> : ""}
            {formData?.url_type == "mp4_video_upload" &&
              <>
                <input class="form-control w-100 h-100" id="live-file-upload" type="file" accept="video/mp4, video/x-matroska, video/x-m4v, video/webm, video/quicktime, video/x-msvideo" onChange={(e) => handleLibraryChange(e)} />
                <AdminCustomButton id={"live-choose-library"} saveMethod={handleToggleGalleryModel} saveText="Choose from library" className="mt-3" />
              </>
            }
            {formData?.url_type === "Encode_stream_video" && (
              <>
                <AdminCustomSelect
                  id="live-encode-stream-video"
                  ref={(el) => (combinedRef.current.rtmp_url = el)}
                  name="rtmp_url"
                  value={formData?.rtmp_url || ""}
                  options={formData?.rtmp_type || []}
                  onChange={handleInput}
                  defaultOptionName="Choose streaming url"
                  error={formDataError?.rtmp_url}
                />
                <FormContainer className={"mb-3"}>
                  <LeftWrapper>
                    <MessageSubHeading text="Keep the Same Stream Key" />
                  </LeftWrapper>
                  <RightWrapper>
                    <AdminSwitch name="streamkey_retain" checked={formData?.streamkey_retain == 1} onChange={handleInput} />
                  </RightWrapper>
                </FormContainer>

                {formData?.hls_url && (
                  <>
                    <MessageSubHeading text={`Hls Url`} className="" />
                    <AdminCustomURLCopy link={formData?.hls_url} fieldName={""} className="copy-board-input" labelClassName="mt-md-2" />
                  </>)}
                {formData?.Stream_key && (
                  <>
                    <MessageSubHeading text={`Stream Key`} className="" />
                    <AdminCustomURLCopy link={formData?.Stream_key} fieldName={""} className="copy-board-input" labelClassName="mt-md-2" />
                  </>
                )}
              </>
            )}

            {/* {formData?.url_type == "m3u_url" && <AdminCustomInput type="text" name="m3u_url" value={formData?.m3u_url} ref={(el) => (combinedRef.current.m3u_url = el)} onChange={handleInput} placeHolder={"m3u_url"} error={formDataError?.m3u_url} />} */}
            {formData?.url_type == "m3u8_url" && <AdminCustomInput id={"live-m3u8-url"} type="text" name="m3u8_url" value={formData?.m3u8_url} ref={(el) => (combinedRef.current.m3u8_url = el)} onChange={handleInput} placeHolder={"Please enter m3u8 url"} error={formDataError?.m3u8_url} />}

          </Wrapper>

          <Wrapper>
            <MessageHeading text={labelDisplay?.[42]?.title} />
            <MessageLabel text={labelDisplay?.[43]?.title} className="mandatorySimple" />
            <MessageSubHeading text={labelDisplay?.[43]?.sub_title} />
            <AdminCustomSelect id={"live-access"} name="access" value={formData?.access || 0} onChange={handleInput} ref={(el) => (combinedRef.current.access = el)} options={defaultOption?.accessOption?.map((item) => ({ name: item?.name, value: item?.value }))} error={formDataError?.access} defaultOptionName={"Choose an user access"} />
            {formData?.access === "ppv" && <>
              {globalPpvStatusActive?.PPV_Individual_Contents == 0 ?
                (
                  <div className="mt-3">
                    <MessageLabel text={labelDisplay?.[61]?.title} />
                    <div className="d-flex justify-content-between mb-2 ">
                      <div className="col-6 col-md-6 pe-2">
                        <MessageSubHeading text={labelDisplay?.[61]?.sub_title} />
                      </div>
                      <div className="col-6 col-md-6 ps-2 text-end">
                        <AdminSwitch id={"live-global-ppv"} name={'global_ppv'} checked={formData?.global_ppv == 1} onChange={handleInput} />
                      </div>
                    </div>
                    <AdminCustomInput id={"live-ppv-price"} isReadonly={formData?.global_ppv == 1} type="text" name="ppv_price" value={formData?.ppv_price} onChange={handleInput} placeHolder={"Please enter ppv price"} ref={(el) => (combinedRef.current.ppv_price = el)} error={formDataError?.ppv_price} />

                    <MessageLabel text={labelDisplay?.[62]?.title} />
                    {/* <div className="d-flex justify-content-between mb-2 ">
                      <div className="col-6 col-md-6 pe-2">
                        <MessageSubHeading text={labelDisplay?.[62]?.sub_title} />
                      </div>
                      <div className="col-6 col-md-6 ps-2 text-end">
                        <AdminSwitch id={"live-global-ios-ppv"} name={'global_ios_ppv'} checked={formData?.global_ios_ppv == 1} onChange={handleInput} />
                      </div>
                    </div> */}
                    <AdminCustomSelect id={"live-ios-ppv-price"} name="ios_ppv_price" value={formData?.ios_ppv_price || 0} onChange={handleInput} ref={(el) => (combinedRef.current.ios_ppv_price = el)} options={defaultOption?.iosOption?.map((item) => ({ name: item?.plan_price, value: item?.id }))} error={formDataError?.ios_ppv_price} defaultOptionName={"Choose an ios price"} />
                  </div>
                )
                :
                <div className="mt-3">
                  <AdminCustomButton id="video-custom-ppv-button" saveMethod={() => handleCustomizePPVClick()} saveText="Customize PPV" className="d-block ms-auto mt-3" />
                </div >
              }
              {/* {Array.isArray(defaultOption?.googleProductIdPPV) && defaultOption.googleProductIdPPV.length > 0 && (
                <div className="mt-3">
                  <MessageLabel text="Google Purchase" />
                  <AdminCustomSelect
                    id="main-live-google-product-ppvs"
                    name="google_product_id_ppvs_id"
                    value={formData?.google_product_id_ppvs_id || ''}
                    onChange={(e) => {
                      const planId = e.target.value;
                      setFormData(prev => ({
                        ...prev,
                        google_product_id_ppvs_id: planId ? parseInt(planId) : null,
                      }));
                    }}
                    options={defaultOption.googleProductIdPPV.map(plan => ({
                      name: plan?.product_id || plan?.name || `Product ${plan?.id}`,
                      value: plan?.id,
                    }))}
                    defaultOptionName="Choose Google Purchase"
                  />
                </div>
              )} */}
            </>}
          </Wrapper >


          {/* <Wrapper>
            <MessageHeading text={labelDisplay?.[26]?.title} />
            <div className="d-flex justify-content-between mb-2 w-100">
              <div className="col-6 col-md-6 pe-2">
                <MessageLabel text={labelDisplay?.[27]?.title} />
              </div>
              <div className="col-6 col-md-6 ps-2 text-end">
                <AdminSwitch id={"live-restream"} name={'enable_restream'} checked={formData?.enable_restream == 1} onChange={handleInput} />
              </div>
            </div>
            {formData?.enable_restream == 1 && (
              <>
                <div className="accordion mt-3" id="accordionSocialExample"  >
                  <div className="accordion-item">
                    <h2 className="accordion-header" id="headingOne">
                      <button className="accordion-button collapsed p-3" type="button" data-bs-toggle="collapse" data-bs-target="#collapseOne" aria-expanded="true" aria-controls="collapseOne"  >
                        <img src={youtube} className="accordionImage" alt="Animated GIF" />
                        <MessageLabel text={labelDisplay?.[28]?.title} className={"ms-2"} noMargin />
                      </button>
                    </h2>
                    <div id="collapseOne" className="accordion-collapse collapse " aria-labelledby="headingOne" data-bs-parent="#accordionSocialExample" >
                      <div className="accordion-body py-3 px-0">
                        <div className="col-12 mb-2 px-3">
                          <div className="d-flex align-item-center gap-3">
                            <MessageLabel text={labelDisplay?.[29]?.title} />
                            <MessageSubHeading text={labelDisplay?.[29]?.sub_title} />
                          </div>
                          <AdminCustomInput id={"live-youtube-restream-url"} type="text" name="youtube_restream_url" value={formData?.youtube_restream_url} onChange={handleInput} placeHolder={"Please fill youtube restream url"} ref={(el) => (combinedRef.current.youtube_restream_url = el)} error={formDataError?.youtube_restream_url} />
                          <MessageLabel text={labelDisplay?.[30]?.title} />
                          <AdminCustomInput id={"live-youtube-streamkey"} type="text" name="youtube_streamkey" value={formData?.youtube_streamkey} onChange={handleInput} placeHolder={"Please fill youtube streamkey"} ref={(el) => (combinedRef.current.youtube_streamkey = el)} error={formDataError?.youtube_streamkey} />
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="accordion-item">
                    <h2 className="accordion-header" id="headingTwo">
                      <button className="accordion-button collapsed p-3" type="button" data-bs-toggle="collapse" data-bs-target="#collapseTwo" aria-expanded="false" aria-controls="collapseTwo"  >
                        <img src={facebook} className="accordionImage" alt="Animated GIF" />
                        <MessageLabel text={labelDisplay?.[32]?.title} className={"ms-2"} noMargin />
                      </button>
                    </h2>
                    <div id="collapseTwo" className="accordion-collapse collapse" aria-labelledby="headingTwo" data-bs-parent="#accordionSocialExample" >
                      <div className="accordion-body py-3 px-0">
                        <div className="col-12 mb-2 px-3">
                          <div className="d-flex align-item-center gap-3">
                            <MessageLabel text={labelDisplay?.[32]?.title} />
                            <MessageSubHeading text={labelDisplay?.[32]?.sub_title} />
                          </div>
                          <AdminCustomInput id={"live-fb-restream-url"} type="text" name="fb_restream_url" value={formData?.fb_restream_url} onChange={handleInput} placeHolder={"Please fill fb restream url"} ref={(el) => (combinedRef.current.fb_restream_url = el)} error={formDataError?.fb_restream_url} />
                          <MessageLabel text={labelDisplay?.[33]?.title} />
                          <AdminCustomInput id={"live-fb_streamkey"} type="text" name="fb_streamkey" value={formData?.fb_streamkey} onChange={handleInput} placeHolder={"Please fill fb streamkey"} ref={(el) => (combinedRef.current.fb_streamkey = el)} error={formDataError?.fb_streamkey} />
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="accordion-item">
                    <h2 className="accordion-header" id="headingThree">
                      <button className="accordion-button collapsed p-3" type="button" data-bs-toggle="collapse" data-bs-target="#collapseThree" aria-expanded="false" aria-controls="collapseThree"   >
                        <img src={twitter} className="accordionImage" alt="Animated GIF" />
                        <MessageLabel text={labelDisplay?.[34]?.title} className={"ms-2"} noMargin />
                      </button>
                    </h2>
                    <div id="collapseThree" className="accordion-collapse collapse" aria-labelledby="headingThree" data-bs-parent="#accordionSocialExample"  >
                      <div className="accordion-body py-3 px-0">
                        <div className="col-12 mb-2 px-3">
                          <div className="d-flex align-item-center gap-3">
                            <MessageLabel text={labelDisplay?.[35]?.title} />
                            <MessageSubHeading text={labelDisplay?.[35]?.sub_title} />
                          </div>
                          <AdminCustomInput id={"live-twitter-restream-url"} type="text" name="twitter_restream_url" value={formData?.twitter_restream_url} onChange={handleInput} placeHolder={"Please fill twitter restream url"} ref={(el) => (combinedRef.current.twitter_restream_url = el)} error={formDataError?.twitter_restream_url} />
                          <MessageLabel text={labelDisplay?.[36]?.title} />
                          <AdminCustomInput id={"live-twitter-streamkey"} type="text" name="twitter_streamkey" value={formData?.twitter_streamkey} onChange={handleInput} placeHolder={"Please fill twitter streamkey"} ref={(el) => (combinedRef.current.twitter_streamkey = el)} error={formDataError?.twitter_streamkey} />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </>
            )}
          </Wrapper> */}

          <Wrapper>
            <MessageHeading text={labelDisplay?.[37]?.title} />
            <MessageLabel text={labelDisplay?.[38]?.title} />
            <div className='d-flex align-items-center justify-content-start gap-3'>
              <AdminCustomRadio id={"live-publish-now"} name="publish_now" checked={formData?.publish_type == "publish_now"} onChange={handleInput} />
              <MessageLabel text={labelDisplay?.[39]?.title} noMargin className={formData?.publish_type == "publish_now" ? "mandatorySimple" : ""} />
            </div>
            {formData?.publish_type == "publish_now" && (<>
              {/* <MessageLabel text={labelDisplay?.[7]?.title} /> */}
              <AdminCustomSelect id={"live-year"} name="year" value={formData?.year} onChange={handleInput} ref={(el) => (combinedRef.current.year = el)} options={years} error={formDataError?.year} defaultOptionName="Choose publish year" />
            </>)}
            <div className='d-flex align-items-center justify-content-start gap-3'>
              <AdminCustomRadio id={"live-publish-later"} name="publish_later" checked={formData?.publish_type == "publish_later"} onChange={handleInput} />
              <MessageLabel text={labelDisplay?.[40]?.title} noMargin className={formData?.publish_type == "publish_later" ? "mandatorySimple" : ""} />
            </div>
            {formData?.publish_type == "publish_later" && (<>
              {/* <MessageLabel text={labelDisplay?.[41]?.title} /> */}
              <AdminCustomInput id={"live-publish-time"} min={new Date().toISOString().slice(0, 16)} type="datetime-local" name="publish_time" value={formData?.publish_time} onChange={handleInput} placeHolder={"time "} ref={(el) => (combinedRef.current.publish_time = el)} error={formDataError?.publish_time} />
            </>)}
          </Wrapper>

          {page_for == "create" &&
            <Wrapper>
              <MessageHeading text={labelDisplay?.[47]?.title} />
              {/* <div className="d-flex justify-content-between mb-2 ">
                <div className="col-6 col-md-6 pe-2">
                  <MessageLabel text={labelDisplay?.[48]?.title} />
                </div>
                <div className="col-6 col-md-6 ps-2 text-end">
                  <AdminSwitch id={"live-featured"} name={'featured'} checked={formData?.featured == 1} onChange={handleInput} />
                </div>
              </div> */}

              <div className="d-flex justify-content-between mb-2 ">
                <div className="col-6 col-md-6 pe-2">
                  <MessageLabel text={labelDisplay?.[49]?.title} />
                </div>
                <div className="col-6 col-md-6 ps-2 text-end">
                  <AdminSwitch id={"live-active"} name={'active'} checked={formData?.active == 1} onChange={handleInput} />
                </div>
              </div>
              <div className="d-flex justify-content-between mb-2 ">
                <div className="col-6 col-md-6 pe-2">
                  <MessageLabel text={labelDisplay?.[50]?.title} />
                </div>
                <div className="col-6 col-md-6 ps-2 text-end">
                  <AdminSwitch id={"live-banner"} name={'banner'} checked={formData?.banner == 1} onChange={handleInput} />
                </div>
              </div>
              {/* <div className="d-flex justify-content-between mb-2 ">
                <div className="col-6 col-md-6 pe-2">
                  <MessageLabel text='Enable record' />
                </div>
                <div className="col-6 col-md-6 ps-2 text-end">
                  <AdminSwitch id={"live-record"} name={'record_enable'} checked={formData?.record_enable == 1} onChange={handleInput} />
                </div>
              </div> */}
              {/* <div className="d-flex justify-content-between mb-2 ">
                <div className="col-6 col-md-6 pe-2">
                  <MessageLabel text={labelDisplay?.[51]?.title} />
                </div>
                <div className="col-6 col-md-6 ps-2 text-end">
                  <AdminSwitch id={"live-enable-chats"} name={'enable_chats'} checked={formData?.enable_chats == 1} onChange={handleInput} />
                </div>
              </div> */}
            </Wrapper>
          }
          {onlyPermission?.includes(44) &&
            <PushNotificationSettings
              formData={formData}
              setFormData={setFormData}
              handleInput={handleInput}
              handleFileChange={handleFileChange}
              selectedFile={notificationImageFile}
              uploadedImage={formData?.push_notification_image}
              onDelete={handleClearSelectFile}
              combinedRef={combinedRef}
              formDataError={formDataError}
              siteTheme={siteTheme}
              id={id}
              onlyPermission={onlyPermission}
              sourceTitle={formData?.title}
              sourceDescription={formData?.description}
              sourceType={2}
              sourceTypeName="Livestream"
              slug={formData?.slug}
              prefix="live-stream"
            />
          }

          <Wrapper>
            <MessageHeading text={labelDisplay?.[16]?.title} />

            <MessageLabel text={labelDisplay?.[17]?.title} />
            <MessageSubHeading text={labelDisplay?.[17]?.sub_title} />
            <AdminCustomInput id={"live-websitePageTitle"} type="text" name="website_page_title" value={formData?.website_page_title} ref={(el) => (combinedRef.current.website_page_title = el)} onChange={handleInput} placeHolder={"Please enter Website title"} error={formDataError?.website_page_title} />

            <MessageLabel text={labelDisplay?.[18]?.title} />
            <MessageSubHeading text={labelDisplay?.[18]?.sub_title} />
            <AdminCustomInput id={"live-websiteUrl"} type="text" name="website_URL" value={formData?.website_URL} onChange={handleInput} placeHolder={"Please enter Website url"} ref={(el) => (combinedRef.current.website_URL = el)} error={formDataError?.website_URL} />

            <MessageLabel text={labelDisplay?.[19]?.title} />
            <MessageSubHeading text={labelDisplay?.[19]?.sub_title} />
            <AdminCustomArea id={"live-metaDescription"} type="text" name="Meta_description" value={formData?.Meta_description} onChange={handleInput} ref={(el) => (combinedRef.current.Meta_description = el)} placeHolder={"Please enter Meta description"} rows={5} />
          </Wrapper>

          {/* <Wrapper>
            <MessageHeading text={labelDisplay?.[52]?.title} />
            <div className="d-flex justify-content-between mb-2 ">
              <div className="col-6 col-md-6 pe-2">
                <MessageLabel text={labelDisplay?.[53]?.title} />
              </div>
              <div className="col-6 col-md-6 ps-2 text-end">
                <AdminSwitch id={"live-enable-tips"} name={'enable_Tips'} checked={formData?.enable_Tips} onChange={handleInput} />
              </div>
            </div>
            {formData?.enable_Tips == 1 && <>
              <MessageSubHeading text={labelDisplay?.[54]?.title} />
              <AdminCustomInput id={"live-donation-label"} ref={(el) => (combinedRef.current.donations_label = el)} type="text" name="donations_label" value={formData?.donations_label} onChange={handleInput} placeHolder={"Please provide donations label"} error={formDataError?.donations_label} />
            </>}
          </Wrapper> */}

        </RightWrapper >
      </FormContainer>
      {Number(siteTheme?.enable_epg) === 1 && (
        <div className="mt-4">
          <div className="d-flex justify-content-between align-items-center mb-4">
            <div>
              <MessageHeading text={"Schedule Programs"} />
              <MessageSubHeading text={`Total Programs: ${formData?.schedule_programs?.length || 0}`} className="text-muted" />
            </div>
            <div>
              <AdminCustomButton
                id="add-schedule-program"
                className="btn-success px-4 py-2"
                saveMethod={handleAddScheduleProgram}
                saveText={"+ Add Program"}
              />
            </div>
          </div>

          {formData?.schedule_programs?.map((program, index) => (
            <div key={program.id} className="border rounded-3 p-3 mb-4 position-relative" style={{ backgroundColor: '#f8f9fa' }}>
              <div className="d-flex justify-content-between align-items-center mb-3">
                <div className="d-flex align-items-center">
                  <div className="bg-primary text-white rounded-circle d-flex align-items-center justify-content-center me-3"
                    style={{ width: '32px', height: '32px', fontSize: '14px', fontWeight: 'bold' }}>
                    {index + 1}
                  </div>
                  <h6 className="mb-0 fw-bold">Program {index + 1}</h6>
                  {program.start_time && program.end_time && (
                    <span className="badge bg-info ms-2">
                      {program.start_time} - {program.end_time}
                    </span>
                  )}
                </div>
                {formData?.schedule_programs?.length > 1 && (
                  <button
                    type="button"
                    className="btn btn-outline-danger btn-sm d-flex align-items-center"
                    onClick={() => handleRemoveScheduleProgram(program.id)}
                  >
                    <IoClose size={16} className="me-1" />
                    {"Remove"}
                  </button>
                )}
              </div>

              <div className="row">
                <LeftWrapper>
                  <Wrapper>
                    <MessageLabel text={"Program Name"} className="mandatorySimple" />
                    <AdminCustomInput
                      id={`schedule-program-name-${program.id}`}
                      type="text"
                      value={program.name}
                      onChange={(e) => handleScheduleProgramChange(program.id, 'name', e.target.value)}
                      placeHolder="Enter program name"
                      error={formDataError?.[`schedule_program_${program.id}_name`]}
                    />

                    <MessageLabel text={"Program Description"} className="mandatorySimple" />
                    <AdminCustomArea
                      id={`schedule-program-description-${program.id}`}
                      value={program.description}
                      onChange={(e) => handleScheduleProgramChange(program.id, 'description', e.target.value)}
                      placeHolder="Enter program description"
                      rows={3}
                      maxLength={"250"}
                    />

                    <MessageLabel text={"Days"} className="mandatorySimple" />
                    <Select
                      id={`schedule-program-days-${program.id}`}
                      options={[
                        { value: 'monday', label: 'Monday' },
                        { value: 'tuesday', label: 'Tuesday' },
                        { value: 'wednesday', label: 'Wednesday' },
                        { value: 'thursday', label: 'Thursday' },
                        { value: 'friday', label: 'Friday' },
                        { value: 'saturday', label: 'Saturday' },
                        { value: 'sunday', label: 'Sunday' }
                      ]}
                      isMulti
                      value={program.selectedDays || []}
                      onChange={(selectedOptions) => {
                        handleScheduleProgramChange(program.id, 'selectedDays', selectedOptions);
                        const daysArray = selectedOptions ? selectedOptions.map(option => option.value) : [];
                        handleScheduleProgramChange(program.id, 'days', daysArray);
                      }}
                      className="custom-select-multi custom-placeholder theme-text-color mb-3"
                      placeholder="Select broadcasting days..."
                      closeMenuOnSelect={false}
                    />
                  </Wrapper>
                </LeftWrapper>

                <RightWrapper>
                  <Wrapper>
                    <div className="row">
                      <div className="col-12 col-md-6 mb-3">
                        <MessageLabel text={"Start Time"} className="mandatorySimple" />
                        <AdminCustomInput
                          id={`schedule-program-start-time-${program.id}`}
                          type="time"
                          value={program.start_time}
                          onChange={(e) => handleScheduleProgramChange(program.id, 'start_time', e.target.value)}
                        />
                      </div>
                      <div className="col-12 col-md-6 mb-3">
                        <MessageLabel text={"End Time"} className="mandatorySimple" />
                        <AdminCustomInput
                          id={`schedule-program-end-time-${program.id}`}
                          type="time"
                          value={program.end_time}
                          onChange={(e) => handleScheduleProgramChange(program.id, 'end_time', e.target.value)}
                        />
                      </div>
                    </div>

                    <MessageLabel text={"Program Image (Optional)"} />
                    <AdminImageUploadZone
                      onChange={(e) => handleScheduleImageChange(e, program.id)}
                      selectedFile={scheduleImageFiles[program.id]}
                      uploadedImage={program.image}
                      onDelete={() => handleClearScheduleImage(program.id)}
                      name={`schedule_program_${program.id}_image`}
                      id={`schedule-program-image-${program.id}`}
                    />
                  </Wrapper>
                </RightWrapper>
              </div>
            </div>
          ))}
        </div>
      )}

      <FormContainer>
        {Number(siteTheme?.enable_epg) === 1 && (
          <AdminCustomButton id="add-schedule-program-bottom" className="btn-success px-4 py-2" saveMethod={handleAddScheduleProgram} saveText="+ Add Another Program" />
        )}
        <AdminCustomButton id={"live-store-button"} className='px-3 py-1 me-3 me-md-0 ms-md-auto' saveMethod={handleStore} saveText={!id ? labelDisplay?.[1]?.title : labelDisplay?.[57]?.title} />
      </FormContainer>

    </div>
  );
};

const mapStateToProps = (state) => ({
  siteTheme: state.siteTheme.siteTheme,
  languageCodeData: state.languageCode.languageCodeData,
  onlyPermission: state.userPermission.onlyPermission
});

export default connect(mapStateToProps)(AddNewLiveStream);